/**
 * @important these are derived from the various reports we can generate
 * and are not exhaustive of all metrics available
 *
 * @see {@link ./report.ts} for the full allotment of supported metrics per support
 */
import { INSIGHTS_TIK_TOK_FILTERABLE_AD_ATTRIBUTES, } from './ad.js';
// Define the TikTok metrics (all the original metrics from TikTok API)
export const TIKTOK_METRICS = {
    // Basic metrics
    spend: 'spend',
    billed_cost: 'billed_cost',
    cash_spend: 'cash_spend',
    voucher_spend: 'voucher_spend',
    cpc: 'cpc',
    cpm: 'cpm',
    impressions: 'impressions',
    gross_impressions: 'gross_impressions',
    clicks: 'clicks',
    ctr: 'ctr',
    reach: 'reach',
    cost_per_1000_reached: 'cost_per_1000_reached',
    frequency: 'frequency',
    conversion: 'conversion',
    cost_per_conversion: 'cost_per_conversion',
    conversion_rate: 'conversion_rate',
    conversion_rate_v2: 'conversion_rate_v2',
    real_time_conversion: 'real_time_conversion',
    real_time_cost_per_conversion: 'real_time_cost_per_conversion',
    real_time_conversion_rate: 'real_time_conversion_rate',
    real_time_conversion_rate_v2: 'real_time_conversion_rate_v2',
    result: 'result',
    cost_per_result: 'cost_per_result',
    result_rate: 'result_rate',
    real_time_result: 'real_time_result',
    real_time_cost_per_result: 'real_time_cost_per_result',
    real_time_result_rate: 'real_time_result_rate',
    secondary_goal_result: 'secondary_goal_result',
    cost_per_secondary_goal_result: 'cost_per_secondary_goal_result',
    secondary_goal_result_rate: 'secondary_goal_result_rate',
    // Video metrics
    video_play_actions: 'video_play_actions',
    video_watched_2s: 'video_watched_2s',
    video_watched_6s: 'video_watched_6s',
    engaged_view: 'engaged_view',
    engaged_view_15s: 'engaged_view_15s',
    video_views_p25: 'video_views_p25',
    video_views_p50: 'video_views_p50',
    video_views_p75: 'video_views_p75',
    video_views_p100: 'video_views_p100',
    average_video_play: 'average_video_play',
    average_video_play_per_user: 'average_video_play_per_user',
    // Engagement metrics
    engagements: 'engagements',
    engagement_rate: 'engagement_rate',
    follows: 'follows',
    likes: 'likes',
    comments: 'comments',
    shares: 'shares',
    profile_visits: 'profile_visits',
    profile_visits_rate: 'profile_visits_rate',
    clicks_on_music_disc: 'clicks_on_music_disc',
    duet_clicks: 'duet_clicks',
    stitch_clicks: 'stitch_clicks',
    sound_usage_clicks: 'sound_usage_clicks',
    anchor_clicks: 'anchor_clicks',
    anchor_click_rate: 'anchor_click_rate',
    clicks_on_hashtag_challenge: 'clicks_on_hashtag_challenge',
    ix_page_duration_avg: 'ix_page_duration_avg',
    ix_page_viewrate_avg: 'ix_page_viewrate_avg',
    ix_video_views: 'ix_video_views',
    ix_video_views_p25: 'ix_video_views_p25',
    ix_video_views_p50: 'ix_video_views_p50',
    ix_video_views_p75: 'ix_video_views_p75',
    ix_video_views_p100: 'ix_video_views_p100',
    ix_average_video_play: 'ix_average_video_play',
    // single_image_impressions: 'single_image_impressions',
    // single_image_impression_rate: 'single_image_impression_rate',
    // single_image_ctr: 'single_image_ctr',
    tt_playlist_visit: 'tt_playlist_visit',
    tt_playlist_visit_rate: 'tt_playlist_visit_rate',
    // Attribution metrics
    vta_complete_payment: 'vta_complete_payment',
    cost_per_vta_payments_completed: 'cost_per_vta_payments_completed',
    vta_complete_payment_value: 'vta_complete_payment_value',
    vta_complete_payment_roas: 'vta_complete_payment_roas',
    // Page event metrics
    total_landing_page_view: 'total_landing_page_view',
    cost_per_landing_page_view: 'cost_per_landing_page_view',
    landing_page_view_rate: 'landing_page_view_rate',
    // App metrics
    real_time_app_install: 'real_time_app_install',
    real_time_app_install_cost: 'real_time_app_install_cost',
    app_install: 'app_install',
    cost_per_app_install: 'cost_per_app_install',
    launch_app: 'launch_app',
    total_launch_app: 'total_launch_app',
    next_day_open: 'next_day_open',
    total_next_day_open: 'total_next_day_open',
    login: 'login',
    total_login: 'total_login',
    search: 'search',
    total_search: 'total_search',
    day7_retention: 'day7_retention',
    total_day7_retention: 'total_day7_retention',
    total_day7_retention_value: 'total_day7_retention_value',
    // Gaming metrics
    achieve_level: 'achieve_level',
    total_achieve_level: 'total_achieve_level',
    total_achieve_level_value: 'total_achieve_level_value',
    complete_tutorial: 'complete_tutorial',
    total_complete_tutorial: 'total_complete_tutorial',
    total_complete_tutorial_value: 'total_complete_tutorial_value',
    create_gamerole: 'create_gamerole',
    total_create_gamerole: 'total_create_gamerole',
    total_create_gamerole_value: 'total_create_gamerole_value',
    unlock_achievement: 'unlock_achievement',
    total_unlock_achievement: 'total_unlock_achievement',
    total_unlock_achievement_value: 'total_unlock_achievement_value',
    // Social metrics
    create_group: 'create_group',
    total_create_group: 'total_create_group',
    total_create_group_value: 'total_create_group_value',
    join_group: 'join_group',
    total_join_group: 'total_join_group',
    total_join_group_value: 'total_join_group_value',
    // In-app ad metrics
    ads_impression_events: 'ads_impression_events',
    total_ad_impression_events_value: 'total_ad_impression_events_value',
    in_app_ad_click: 'in_app_ad_click',
    total_in_app_ad_click: 'total_in_app_ad_click',
    total_in_app_ad_click_value: 'total_in_app_ad_click_value',
    in_app_ad_impr: 'in_app_ad_impr',
    total_in_app_ad_impr: 'total_in_app_ad_impr',
    total_in_app_ad_impr_value: 'total_in_app_ad_impr_value',
    unique_ad_impression_events: 'unique_ad_impression_events',
    // Finance metrics
    loan_apply: 'loan_apply',
    total_loan_apply: 'total_loan_apply',
    loan_credit: 'loan_credit',
    total_loan_credit: 'total_loan_credit',
    loan_disbursement: 'loan_disbursement',
    total_loan_disbursement: 'total_loan_disbursement',
    spend_credits: 'spend_credits',
    total_spend_credits: 'total_spend_credits',
    total_spend_credits_value: 'total_spend_credits_value',
    // Custom event metrics
    custom_app_events: 'custom_app_events',
    custom_app_events_value: 'custom_app_events_value',
    unique_custom_app_events: 'unique_custom_app_events',
    view_content: 'view_content',
    total_view_content: 'total_view_content',
    total_view_content_value: 'total_view_content_value',
    ratings: 'ratings',
    total_ratings: 'total_ratings',
    total_ratings_value: 'total_ratings_value',
    // Conversion metrics
    registration: 'registration',
    cost_per_registration: 'cost_per_registration',
    registration_rate: 'registration_rate',
    total_registration: 'total_registration',
    cost_per_total_registration: 'cost_per_total_registration',
    cta_conversion: 'cta_conversion',
    cta_purchase: 'cta_purchase',
    purchase: 'purchase',
    cost_per_purchase: 'cost_per_purchase',
    purchase_rate: 'purchase_rate',
    total_purchase: 'total_purchase',
    cost_per_total_purchase: 'cost_per_total_purchase',
    value_per_total_purchase: 'value_per_total_purchase',
    total_purchase_value: 'total_purchase_value',
    total_active_pay_roas: 'total_active_pay_roas',
    app_event_add_to_cart: 'app_event_add_to_cart',
    cost_per_app_event_add_to_cart: 'cost_per_app_event_add_to_cart',
    app_event_add_to_cart_rate: 'app_event_add_to_cart_rate',
    total_app_event_add_to_cart: 'total_app_event_add_to_cart',
    cost_per_total_app_event_add_to_cart: 'cost_per_total_app_event_add_to_cart',
    value_per_total_app_event_add_to_cart: 'value_per_total_app_event_add_to_cart',
    total_app_event_add_to_cart_value: 'total_app_event_add_to_cart_value',
    checkout: 'checkout',
    cost_per_checkout: 'cost_per_checkout',
    checkout_rate: 'checkout_rate',
    total_checkout: 'total_checkout',
    cost_per_total_checkout: 'cost_per_total_checkout',
    value_per_checkout: 'value_per_checkout',
    total_checkout_value: 'total_checkout_value',
    sales_lead: 'sales_lead',
    cost_per_sales_lead: 'cost_per_sales_lead',
    sales_lead_rate: 'sales_lead_rate',
    total_sales_lead: 'total_sales_lead',
    cost_per_total_sales_lead: 'cost_per_total_sales_lead',
    value_per_total_sales_lead: 'value_per_total_sales_lead',
    total_sales_lead_value: 'total_sales_lead_value',
    start_trial: 'start_trial',
    cost_per_start_trial: 'cost_per_start_trial',
    start_trial_rate: 'start_trial_rate',
    total_start_trial: 'total_start_trial',
    cost_per_total_start_trial: 'cost_per_total_start_trial',
    subscribe: 'subscribe',
    cost_per_subscribe: 'cost_per_subscribe',
    subscribe_rate: 'subscribe_rate',
    total_subscribe: 'total_subscribe',
    cost_per_total_subscribe: 'cost_per_total_subscribe',
    value_per_total_subscribe: 'value_per_total_subscribe',
    total_subscribe_value: 'total_subscribe_value',
    // web event add to carts
    web_event_add_to_cart: 'web_event_add_to_cart',
    cost_per_web_event_add_to_cart: ' cost_per_web_event_add_to_cart',
    web_event_add_to_cart_rate: ' web_event_add_to_cart_rate',
    value_per_web_event_add_to_cart: 'value_per_web_event_add_to_cart',
    total_web_event_add_to_cart_value: 'total_web_event_add_to_cart_value',
    on_web_order: 'on_web_order',
    cost_per_on_web_order: 'cost_per_on_web_order',
    on_web_order_rate: 'on_web_order_rate',
    value_per_on_web_order: 'value_per_on_web_order',
    total_on_web_order_value: 'total_on_web_order_value',
    // checkout
    initiate_checkout: 'initiate_checkout',
    cost_per_initiate_checkout: 'cost_per_initiate_checkout',
    initiate_checkout_rate: 'initiate_checkout_rate',
    value_per_initiate_checkout: 'value_per_initiate_checkout',
    total_initiate_checkout_value: ' total_initiate_checkout_value',
    // payment shit
    add_billing: 'add_billing',
    cost_per_add_billing: 'cost_per_add_billing',
    add_billing_rate: 'add_billing_rate',
    value_per_add_billing: 'value_per_add_billing',
    total_add_billing_value: 'total_add_billing_value',
    // search
    page_event_search: 'page_event_search',
    cost_per_page_event_search: 'cost_per_page_event_search',
    page_event_search_rate: 'page_event_search_rate',
    value_per_page_event_search: 'value_per_page_event_search',
    total_page_event_search_value: 'total_page_event_search_value',
    //form
    form: 'form',
    cost_per_form: 'cost_per_form',
    form_rate: 'form_rate',
    value_per_form: 'value_per_form',
    total_form_value: 'total_form_value',
    // download
    download_start: 'download_start',
    cost_per_download_start: 'cost_per_download_start',
    download_start_rate: 'download_start_rate',
    value_per_download_start: 'value_per_download_start',
    total_download_start_value: 'total_download_start_value',
    // add to wishlist
    on_web_add_to_wishlist: 'on_web_add_to_wishlist',
    cost_per_on_web_add_to_wishlist: 'cost_per_on_web_add_to_wishlist',
    on_web_add_to_wishlist_per_click: 'on_web_add_to_wishlist_per_click',
    value_per_on_web_add_to_wishlist: 'value_per_on_web_add_to_wishlist',
    total_on_web_add_to_wishlist_value: 'total_on_web_add_to_wishlist_value',
    // subscribe
    on_web_subscribe: 'on_web_subscribe',
    cost_per_on_web_subscribe: 'cost_per_on_web_subscribe',
    on_web_subscribe_per_click: 'on_web_subscribe_per_click',
    value_per_on_web_subscribe: 'value_per_on_web_subscribe',
    total_on_web_subscribe_value: 'total_on_web_subscribe_value',
    custom_page_events: 'custom_page_events',
    cost_per_custom_page_event: 'cost_per_custom_page_event',
    custom_page_event_rate: 'custom_page_event_rate',
    value_per_custom_page_event: 'value_per_custom_page_event',
    custom_page_events_value: 'custom_page_events_value',
    onsite_add_to_wishlist: 'onsite_add_to_wishlist',
    cost_per_onsite_add_to_wishlist: 'cost_per_onsite_add_to_wishlist',
    onsite_add_to_wishlist_rate: 'onsite_add_to_wishlist_rate',
    value_per_onsite_add_to_wishlist: 'value_per_onsite_add_to_wishlist',
    total_onsite_add_to_wishlist_value: 'total_onsite_add_to_wishlist_value',
    onsite_add_billing: 'onsite_add_billing',
    cost_per_onsite_add_billing: 'cost_per_onsite_add_billing',
    onsite_add_billing_rate: 'onsite_add_billing_rate',
    value_per_onsite_add_billing: 'value_per_onsite_add_billing',
    total_onsite_add_billing_value: 'total_onsite_add_billing_value',
    onsite_form: 'onsite_form',
    cost_per_onsite_form: 'cost_per_onsite_form',
    onsite_form_rate: 'onsite_form_rate',
    value_per_onsite_form: 'value_per_onsite_form',
    total_onsite_form_value: 'total_onsite_form_value',
    onsite_download_start: 'onsite_download_start',
    cost_per_onsite_download_start: 'cost_per_onsite_download_start',
    onsite_download_start_rate: 'onsite_download_start_rate',
    onsite_destination_visits: 'onsite_destination_visits',
    cost_per_onsite_destination_visit: 'cost_per_onsite_destination_visit',
    onsite_destination_visit_rate: 'onsite_destination_visit_rate',
    ix_page_view_count: 'ix_page_view_count',
    cost_per_ix_page_view_count: 'cost_per_ix_page_view_count',
    ix_page_view_count_rate: 'ix_page_view_count_rate',
    ix_button_click_count: 'ix_button_click_count',
    cost_per_ix_button_click_count: 'cost_per_ix_button_click_count',
    ix_button_click_count_rate: 'ix_button_click_count_rate',
    ix_product_click_count: 'ix_product_click_count',
    cost_per_ix_product_click_count: 'cost_per_ix_product_click_count',
    ix_product_click_count_rate: 'ix_product_click_count_rate',
    offline_shopping_events: 'offline_shopping_events',
    cost_per_offline_shopping_event: 'cost_per_offline_shopping_event',
    offline_shopping_event_rate: 'offline_shopping_event_rate',
    value_per_offline_shopping_event: 'value_per_offline_shopping_event',
    offline_shopping_events_value: 'offline_shopping_events_value',
    offline_shopping_events_roas: 'offline_shopping_events_roas',
    offline_contact_events: 'offline_contact_events',
    cost_per_offline_contact_event: 'cost_per_offline_contact_event',
    offline_contact_event_rate: 'offline_contact_event_rate',
    value_per_offline_contact_event: 'value_per_offline_contact_event',
    offline_contact_events_value: 'offline_contact_events_value',
    offline_subscribe_events: 'offline_subscribe_events',
    cost_per_offline_subscribe_event: 'cost_per_offline_subscribe_event',
    offline_subscribe_event_rate: 'offline_subscribe_event_rate',
    value_per_offline_subscribe_event: 'value_per_offline_subscribe_event',
    offline_subscribe_events_value: 'offline_subscribe_events_value',
    offline_form_events: 'offline_form_events',
    cost_per_offline_form_event: 'cost_per_offline_form_event',
    offline_form_event_rate: 'offline_form_event_rate',
    value_per_offline_form_event: 'value_per_offline_form_event',
    offline_form_events_value: 'offline_form_events_value',
    offline_add_payment_info_events: 'offline_add_payment_info_events',
    cost_per_offline_add_payment_info_event: 'cost_per_offline_add_payment_info_event',
    offline_add_payment_info_event_rate: 'offline_add_payment_info_event_rate',
    value_per_offline_add_payment_info_event: 'value_per_offline_add_payment_info_event',
    offline_add_payment_info_events_value: 'offline_add_payment_info_events_value',
    offline_add_to_cart_events: 'offline_add_to_cart_events',
    cost_per_offline_add_to_cart_event: 'cost_per_offline_add_to_cart_event',
    offline_add_to_cart_event_rate: 'offline_add_to_cart_event_rate',
    value_per_offline_add_to_cart_event: 'value_per_offline_add_to_cart_event',
    offline_add_to_cart_events_value: 'offline_add_to_cart_events_value',
    offline_add_to_wishlist_events: 'offline_add_to_wishlist_events',
    cost_per_offline_add_to_wishlist_event: 'cost_per_offline_add_to_wishlist_event',
    offline_add_to_wishlist_event_rate: 'offline_add_to_wishlist_event_rate',
    value_per_offline_add_to_wishlist_event: 'value_per_offline_add_to_wishlist_event',
    offline_add_to_wishlist_events_value: 'offline_add_to_wishlist_events_value',
    offline_click_button_events: 'offline_click_button_events',
    cost_per_offline_click_button_event: 'cost_per_offline_click_button_event',
    offline_click_button_event_rate: 'offline_click_button_event_rate',
    value_per_offline_click_button_event: 'value_per_offline_click_button_event',
    offline_click_button_events_value: 'offline_click_button_events_value',
    offline_complete_registration_events: 'offline_complete_registration_events',
    cost_per_offline_complete_registration_event: 'cost_per_offline_complete_registration_event',
    offline_complete_registration_event_rate: 'offline_complete_registration_event_rate',
    value_per_offline_complete_registration_event: 'value_per_offline_complete_registration_event',
    offline_complete_registration_events_value: 'offline_complete_registration_events_value',
    offline_download_events: 'offline_download_events',
    cost_per_offline_download_event: 'cost_per_offline_download_event',
    offline_download_event_rate: 'offline_download_event_rate',
    value_per_offline_download_event: 'value_per_offline_download_event',
    offline_download_events_value: 'offline_download_events_value',
    offline_initiate_checkout_events: 'offline_initiate_checkout_events',
    cost_per_offline_initiate_checkout_event: 'cost_per_offline_initiate_checkout_event',
    offline_initiate_checkout_event_rate: 'offline_initiate_checkout_event_rate',
    value_per_offline_initiate_checkout_event: 'value_per_offline_initiate_checkout_event',
    offline_initiate_checkout_events_value: 'offline_initiate_checkout_events_value',
    offline_place_order_events: 'offline_place_order_events',
    cost_per_offline_place_order_event: 'cost_per_offline_place_order_event',
    offline_place_order_event_rate: 'offline_place_order_event_rate',
    value_per_offline_place_order_event: 'value_per_offline_place_order_event',
    offline_place_order_events_value: 'offline_place_order_events_value',
    offline_search_events: 'offline_search_events',
    cost_per_offline_search_event: 'cost_per_offline_search_event',
    offline_search_event_rate: 'offline_search_event_rate',
    value_per_offline_search_event: 'value_per_offline_search_event',
    offline_search_events_value: 'offline_search_events_value',
    offline_view_content_events: 'offline_view_content_events',
    cost_per_offline_view_content_event: 'cost_per_offline_view_content_event',
    offline_view_content_event_rate: 'offline_view_content_event_rate',
    value_per_offline_view_content_event: 'value_per_offline_view_content_event',
    offline_view_content_events_value: 'offline_view_content_events_value',
    skan_result: 'skan_result',
    skan_cost_per_result: 'skan_cost_per_result',
    skan_result_rate: 'skan_result_rate',
    skan_conversion: 'skan_conversion',
    skan_cost_per_conversion: 'skan_cost_per_conversion',
    skan_conversion_rate: 'skan_conversion_rate',
    skan_conversion_rate_v2: 'skan_conversion_rate_v2',
    skan_click_time_conversion: 'skan_click_time_conversion',
    skan_click_time_cost_per_conversion: 'skan_click_time_cost_per_conversion',
    skan_click_time_conversion_rate: 'skan_click_time_conversion_rate',
    skan_click_time_conversion_rate_v2: 'skan_click_time_conversion_rate_v2',
    skan_app_install: 'skan_app_install',
    skan_cost_per_app_install: 'skan_cost_per_app_install',
    skan_app_install_withheld: 'skan_app_install_withheld',
    skan_registration: 'skan_registration',
    skan_cost_per_registration: 'skan_cost_per_registration',
    skan_registration_rate: 'skan_registration_rate',
    skan_total_registration: 'skan_total_registration',
    skan_cost_per_total_registration: 'skan_cost_per_total_registration',
    skan_purchase: 'skan_purchase',
    skan_cost_per_purchase: 'skan_cost_per_purchase',
    skan_purchase_rate: 'skan_purchase_rate',
    skan_total_purchase: 'skan_total_purchase',
    skan_cost_per_total_purchase: 'skan_cost_per_total_purchase',
    skan_total_purchase_value: 'skan_total_purchase_value',
    skan_total_repetitive_active_pay_roas: 'skan_total_repetitive_active_pay_roas',
    skan_add_to_cart: 'skan_add_to_cart',
    skan_cost_per_add_to_cart: 'skan_cost_per_add_to_cart',
    skan_add_to_cart_rate: 'skan_add_to_cart_rate',
    skan_total_add_to_cart: 'skan_total_add_to_cart',
    skan_cost_per_total_add_to_cart: 'skan_cost_per_total_add_to_cart',
    skan_total_add_to_cart_value: 'skan_total_add_to_cart_value',
    skan_checkout: 'skan_checkout',
    skan_cost_per_checkout: 'skan_cost_per_checkout',
    skan_checkout_rate: 'skan_checkout_rate',
    skan_total_checkout: 'skan_total_checkout',
    skan_cost_per_total_checkout: 'skan_cost_per_total_checkout',
    skan_total_checkout_value: 'skan_total_checkout_value',
    skan_view_content: 'skan_view_content',
    skan_cost_per_view_content: 'skan_cost_per_view_content',
    skan_view_content_rate: 'skan_view_content_rate',
    skan_total_view_content: 'skan_total_view_content',
    skan_cost_per_total_view_content: 'skan_cost_per_total_view_content',
    skan_total_view_content_value: 'skan_total_view_content_value',
    skan_add_payment_info: 'skan_add_payment_info',
    skan_cost_per_add_payment_info: 'skan_cost_per_add_payment_info',
    skan_add_payment_info_rate: 'skan_add_payment_info_rate',
    skan_total_add_payment_info: 'skan_total_add_payment_info',
    skan_cost_total_add_payment_info: 'skan_cost_total_add_payment_info',
    skan_add_to_wishlist: 'skan_add_to_wishlist',
    skan_cost_per_add_to_wishlist: 'skan_cost_per_add_to_wishlist',
    skan_add_to_wishlist_rate: 'skan_add_to_wishlist_rate',
    skan_total_add_to_wishlist: 'skan_total_add_to_wishlist',
    skan_cost_per_total_add_to_wishlist: 'skan_cost_per_total_add_to_wishlist',
    skan_total_add_to_wishlist_value: 'skan_total_add_to_wishlist_value',
    skan_launch_app: 'skan_launch_app',
    skan_cost_per_launch_app: 'skan_cost_per_launch_app',
    skan_launch_app_rate: 'skan_launch_app_rate',
    skan_total_launch_app: 'skan_total_launch_app',
    skan_cost_per_total_launch_app: 'skan_cost_per_total_launch_app',
    skan_total_complete_tutorial: 'skan_total_complete_tutorial',
    skan_cost_per_total_complete_tutorial: 'skan_cost_per_total_complete_tutorial',
    skan_complete_tutorial: 'skan_complete_tutorial',
    skan_cost_per_complete_tutorial: 'skan_cost_per_complete_tutorial',
    skan_complete_tutorial_rate: 'skan_complete_tutorial_rate',
    skan_total_complete_tutorial_value: 'skan_total_complete_tutorial_value',
    skan_create_group: 'skan_create_group',
    skan_cost_per_create_group: 'skan_cost_per_create_group',
    skan_create_group_rate: 'skan_create_group_rate',
    skan_total_create_group: 'skan_total_create_group',
    skan_cost_per_total_create_group: 'skan_cost_per_total_create_group',
    skan_total_create_group_value: 'skan_total_create_group_value',
    skan_join_group: 'skan_join_group',
    skan_cost_per_join_group: 'skan_cost_per_join_group',
    skan_join_group_rate: 'skan_join_group_rate',
    skan_total_join_group: 'skan_total_join_group',
    skan_cost_per_total_join_group: 'skan_cost_per_total_join_group',
    skan_total_join_group_value: 'skan_total_join_group_value',
    skan_create_gamerole: 'skan_create_gamerole',
    skan_cost_per_create_gamerole: 'skan_cost_per_create_gamerole',
    skan_create_gamerole_rate: 'skan_create_gamerole_rate',
    skan_total_create_gamerole: 'skan_total_create_gamerole',
    skan_cost_per_total_create_gamerole: 'skan_cost_per_total_create_gamerole',
    skan_total_create_gamerole_value: 'skan_total_create_gamerole_value',
    skan_spend_credits: 'skan_spend_credits',
    skan_cost_per_spend_credits: 'skan_cost_per_spend_credits',
    skan_spend_credits_rate: 'skan_spend_credits_rate',
    skan_total_spend_credits: 'skan_total_spend_credits',
    skan_cost_per_total_spend_credits: 'skan_cost_per_total_spend_credits',
    skan_total_spend_credits_value: 'skan_total_spend_credits_value',
    skan_achieve_level: 'skan_achieve_level',
    skan_cost_per_achieve_level: 'skan_cost_per_achieve_level',
    skan_achieve_level_rate: 'skan_achieve_level_rate',
    skan_total_achieve_level: 'skan_total_achieve_level',
    skan_cost_per_total_achieve_level: 'skan_cost_per_total_achieve_level',
    skan_total_achieve_level_value: 'skan_total_achieve_level_value',
    skan_unlock_achievement: 'skan_unlock_achievement',
    skan_cost_per_unlock_achievement: 'skan_cost_per_unlock_achievement',
    skan_unlock_achievement_rate: 'skan_unlock_achievement_rate',
    skan_total_unlock_achievement: 'skan_total_unlock_achievement',
    skan_cost_per_total_unlock_achievement: 'skan_cost_per_total_unlock_achievement',
    skan_total_unlock_achievement_value: 'skan_total_unlock_achievement_value',
    skan_sales_lead: 'skan_sales_lead',
    skan_cost_per_sales_lead: 'skan_cost_per_sales_lead',
    skan_sales_lead_rate: 'skan_sales_lead_rate',
    skan_total_sales_lead: 'skan_total_sales_lead',
    skan_cost_per_total_sales_lead: 'skan_cost_per_total_sales_lead',
    skan_total_sales_lead_value: 'skan_total_sales_lead_value',
    skan_in_app_ad_click: 'skan_in_app_ad_click',
    skan_cost_per_in_app_ad_click: 'skan_cost_per_in_app_ad_click',
    skan_in_app_ad_click_rate: 'skan_in_app_ad_click_rate',
    skan_total_in_app_ad_click: 'skan_total_in_app_ad_click',
    skan_cost_per_total_in_app_ad_click: 'skan_cost_per_total_in_app_ad_click',
    skan_total_in_app_ad_click_value: 'skan_total_in_app_ad_click_value',
    skan_in_app_ad_impr: 'skan_in_app_ad_impr',
    skan_cost_per_in_app_ad_impr: 'skan_cost_per_in_app_ad_impr',
    skan_in_app_ad_impr_rate: 'skan_in_app_ad_impr_rate',
    skan_total_in_app_ad_impr: 'skan_total_in_app_ad_impr',
    skan_cost_per_total_in_app_ad_impr: 'skan_cost_per_total_in_app_ad_impr',
    skan_total_in_app_ad_impr_value: 'skan_total_in_app_ad_impr_value',
    skan_loan_apply: 'skan_loan_apply',
    skan_cost_per_loan_apply: 'skan_cost_per_loan_apply',
    skan_loan_apply_rate: 'skan_loan_apply_rate',
    skan_total_loan_apply: 'skan_total_loan_apply',
    skan_cost_per_total_loan_apply: 'skan_cost_per_total_loan_apply',
    skan_loan_credit: 'skan_loan_credit',
    skan_cost_per_loan_credit: 'skan_cost_per_loan_credit',
    skan_loan_credit_rate: 'skan_loan_credit_rate',
    skan_total_loan_credit: 'skan_total_loan_credit',
    skan_cost_per_total_loan_credit: 'skan_cost_per_total_loan_credit',
    skan_loan_disbursement: 'skan_loan_disbursement',
    skan_cost_per_loan_disbursement: 'skan_cost_per_loan_disbursement',
    skan_loan_disbursement_rate: 'skan_loan_disbursement_rate',
    skan_total_loan_disbursement: 'skan_total_loan_disbursement',
    skan_cost_per_total_loan_disbursement: 'skan_cost_per_total_loan_disbursement',
    skan_login: 'skan_login',
    skan_cost_per_login: 'skan_cost_per_login',
    skan_login_rate: 'skan_login_rate',
    skan_total_login: 'skan_total_login',
    skan_cost_per_total_login: 'skan_cost_per_total_login',
    skan_ratings: 'skan_ratings',
    skan_cost_per_ratings: 'skan_cost_per_ratings',
    skan_ratings_rate: 'skan_ratings_rate',
    skan_total_ratings: 'skan_total_ratings',
    skan_cost_per_total_ratings: 'skan_cost_per_total_ratings',
    skan_total_ratings_value: 'skan_total_ratings_value',
    skan_search: 'skan_search',
    skan_cost_per_search: 'skan_cost_per_search',
    skan_search_rate: 'skan_search_rate',
    skan_total_search: 'skan_total_search',
    skan_cost_per_total_search: 'skan_cost_per_total_search',
    skan_start_trial: 'skan_start_trial',
    skan_cost_per_start_trial: 'skan_cost_per_start_trial',
    skan_start_trial_rate: 'skan_start_trial_rate',
    skan_total_start_trial: 'skan_total_start_trial',
    skan_cost_per_total_start_trial: 'skan_cost_per_total_start_trial',
    skan_subscribe: 'skan_subscribe',
    skan_cost_per_subscribe: 'skan_cost_per_subscribe',
    skan_subscribe_rate: 'skan_subscribe_rate',
    skan_total_subscribe: 'skan_total_subscribe',
    skan_cost_per_total_subscribe: 'skan_cost_per_total_subscribe',
    skan_total_subscribe_value: 'skan_total_subscribe_value',
    skan_vta_conversion: 'skan_vta_conversion',
    skan_cost_per_vta_conversion: 'skan_cost_per_vta_conversion',
    skan_vta_app_install: 'skan_vta_app_install',
    skan_cost_per_vta_app_install: 'skan_cost_per_vta_app_install',
    skan_vta_registration: 'skan_vta_registration',
    skan_cost_per_vta_registration: 'skan_cost_per_vta_registration',
    skan_vta_purchase: 'skan_vta_purchase',
    skan_cost_per_vta_purchase: 'skan_cost_per_vta_purchase',
    skan_cta_conversion: 'skan_cta_conversion',
    skan_cost_per_cta_conversion: 'skan_cost_per_cta_conversion',
    skan_cta_app_install: 'skan_cta_app_install',
    skan_cost_per_cta_app_install: 'skan_cost_per_cta_app_install',
    skan_cta_registration: 'skan_cta_registration',
    skan_cost_per_cta_registration: 'skan_cost_per_cta_registration',
    skan_cta_purchase: 'skan_cta_purchase',
    skan_cost_per_cta_purchase: 'skan_cost_per_cta_purchase',
};
export const INSIGHTS_TIKTOK_ATTRIBUTE_FIELDS = {
    advertiser_name: 'advertiser_name',
    advertiser_id: 'advertiser_id',
    campaign_name: 'campaign_name',
    campaign_id: 'campaign_id',
    objective_type: 'objective_type',
    split_test: 'split_test',
    campaign_budget: 'campaign_budget',
    campaign_dedicate_type: 'campaign_dedicate_type',
    app_promotion_type: 'app_promotion_type',
    adgroup_name: 'adgroup_name',
    adgroup_id: 'adgroup_id',
    placement_type: 'placement_type',
    promotion_type: 'promotion_type',
    opt_status: 'opt_status',
    adgroup_download_url: 'adgroup_download_url',
    profile_image: 'profile_image',
    dpa_target_audience_type: 'dpa_target_audience_type',
    budget: 'budget',
    smart_target: 'smart_target',
    /** @deprecated */
    pricing_category: 'pricing_category',
    billing_event: 'billing_event',
    bid_strategy: 'bid_strategy',
    bid: 'bid',
    bid_secondary_goal: 'bid_secondary_goal',
    aeo_type: 'aeo_type',
    ad_name: 'ad_name',
    ad_id: 'ad_id',
    ad_text: 'ad_text',
    call_to_action: 'call_to_action',
    ad_profile_image: 'ad_profile_image',
    ad_url: 'ad_url',
    tt_app_id: 'tt_app_id',
    tt_app_name: 'tt_app_name',
    mobile_app_id: 'mobile_app_id',
    image_mode: 'image_mode',
    currency: 'currency',
    is_aco: 'is_aco',
    is_smart_creative: 'is_smart_creative',
    device_brand_name: 'device_brand_name',
    behavior_name: 'behavior_name',
    action_category: 'action_category',
    action_scene: 'action_scene',
    user_action: 'user_action',
    action_period: 'action_period',
    rf_campaign_type: 'rf_campaign_type',
    delivery_type: 'delivery_type',
    adgroup_display_name: 'adgroup_display_name',
    adgroup_schedule: 'adgroup_schedule',
    optimization_preference: 'optimization_preference',
    image_info: 'image_info',
    ad_display_name: 'ad_display_name',
    identity_type: 'identity_type',
};
export const INSIGHTS_TIKTOK_APP_METRICS = {
    real_time_app_install: 'real_time_app_install',
    real_time_app_install_cost: 'real_time_app_install_cost',
    app_install: 'app_install',
    cost_per_app_install: 'cost_per_app_install',
    launch_app: 'launch_app',
    total_launch_app: 'total_launch_app',
    next_day_open: 'next_day_open',
    total_next_day_open: 'total_next_day_open',
    login: 'login',
    total_login: 'total_login',
    search: 'search',
    total_search: 'total_search',
    day7_retention: 'day7_retention',
    total_day7_retention: 'total_day7_retention',
    total_day7_retention_value: 'total_day7_retention_value',
};
export const INSIGHTS_TIKTOK_GAMING_METRICS = {
    // Gaming related metrics
    achieve_level: 'achieve_level',
    total_achieve_level: 'total_achieve_level',
    total_achieve_level_value: 'total_achieve_level_value',
    complete_tutorial: 'complete_tutorial',
    total_complete_tutorial: 'total_complete_tutorial',
    total_complete_tutorial_value: 'total_complete_tutorial_value',
    create_gamerole: 'create_gamerole',
    total_create_gamerole: 'total_create_gamerole',
    total_create_gamerole_value: 'total_create_gamerole_value',
    unlock_achievement: 'unlock_achievement',
    total_unlock_achievement: 'total_unlock_achievement',
    total_unlock_achievement_value: 'total_unlock_achievement_value',
};
export const INSIGHTS_TIKTOK_SOCIAL_METRICS = {
    // Social interaction metrics
    create_group: 'create_group',
    total_create_group: 'total_create_group',
    total_create_group_value: 'total_create_group_value',
    join_group: 'join_group',
    total_join_group: 'total_join_group',
    total_join_group_value: 'total_join_group_value',
};
export const INSIGHTS_TIKTOK_IN_APP_AD_METRICS = {
    // In-app ad metrics
    ads_impression_events: 'ads_impression_events',
    total_ad_impression_events_value: 'total_ad_impression_events_value',
    in_app_ad_click: 'in_app_ad_click',
    total_in_app_ad_click: 'total_in_app_ad_click',
    total_in_app_ad_click_value: 'total_in_app_ad_click_value',
    in_app_ad_impr: 'in_app_ad_impr',
    total_in_app_ad_impr: 'total_in_app_ad_impr',
    total_in_app_ad_impr_value: 'total_in_app_ad_impr_value',
    unique_ad_impression_events: 'unique_ad_impression_events',
};
export const INSIGHTS_TIKTOK_FINANCE_METRICS = {
    // Finance/credit metrics
    loan_apply: 'loan_apply',
    total_loan_apply: 'total_loan_apply',
    loan_credit: 'loan_credit',
    total_loan_credit: 'total_loan_credit',
    loan_disbursement: 'loan_disbursement',
    total_loan_disbursement: 'total_loan_disbursement',
    spend_credits: 'spend_credits',
    total_spend_credits: 'total_spend_credits',
    total_spend_credits_value: 'total_spend_credits_value',
};
export const INSIGHTS_TIKTOK_CUSTOM_EVENT_METRICS = {
    custom_app_events: 'custom_app_events',
    custom_app_events_value: 'custom_app_events_value',
    unique_custom_app_events: 'unique_custom_app_events',
    view_content: 'view_content',
    total_view_content: 'total_view_content',
    total_view_content_value: 'total_view_content_value',
    ratings: 'ratings',
    total_ratings: 'total_ratings',
    total_ratings_value: 'total_ratings_value',
    custom_page_events: 'custom_page_events',
    cost_per_custom_page_event: 'cost_per_custom_page_event',
    custom_page_event_rate: 'custom_page_event_rate',
    value_per_custom_page_event: 'value_per_custom_page_event',
    custom_page_events_value: 'custom_page_events_value',
};
// Conversion metrics (registration, purchase, etc.)
export const INSIGHTS_TIKTOK_CONVERSION_METRICS = {
    // Registration
    registration: 'registration',
    cost_per_registration: 'cost_per_registration',
    registration_rate: 'registration_rate',
    total_registration: 'total_registration',
    cost_per_total_registration: 'cost_per_total_registration',
    cta_conversion: 'cta_conversion',
    cta_purchase: 'cta_purchase',
    // Purchase
    purchase: 'purchase',
    cost_per_purchase: 'cost_per_purchase',
    purchase_rate: 'purchase_rate',
    total_purchase: 'total_purchase',
    cost_per_total_purchase: 'cost_per_total_purchase',
    value_per_total_purchase: 'value_per_total_purchase',
    total_purchase_value: 'total_purchase_value',
    total_active_pay_roas: 'total_active_pay_roas',
    // Add to cart
    app_event_add_to_cart: 'app_event_add_to_cart',
    cost_per_app_event_add_to_cart: 'cost_per_app_event_add_to_cart',
    app_event_add_to_cart_rate: 'app_event_add_to_cart_rate',
    total_app_event_add_to_cart: 'total_app_event_add_to_cart',
    cost_per_total_app_event_add_to_cart: 'cost_per_total_app_event_add_to_cart',
    value_per_total_app_event_add_to_cart: 'value_per_total_app_event_add_to_cart',
    total_app_event_add_to_cart_value: 'total_app_event_add_to_cart_value',
    // Web event add to cart
    web_event_add_to_cart: 'web_event_add_to_cart',
    cost_per_web_event_add_to_cart: 'cost_per_web_event_add_to_cart',
    web_event_add_to_cart_rate: 'web_event_add_to_cart_rate',
    value_per_web_event_add_to_cart: 'value_per_web_event_add_to_cart',
    total_web_event_add_to_cart_value: 'total_web_event_add_to_cart_value',
    // Checkout
    checkout: 'checkout',
    cost_per_checkout: 'cost_per_checkout',
    checkout_rate: 'checkout_rate',
    total_checkout: 'total_checkout',
    cost_per_total_checkout: 'cost_per_total_checkout',
    value_per_checkout: 'value_per_checkout',
    total_checkout_value: 'total_checkout_value',
    // Initiate checkout
    initiate_checkout: 'initiate_checkout',
    cost_per_initiate_checkout: 'cost_per_initiate_checkout',
    initiate_checkout_rate: 'initiate_checkout_rate',
    value_per_initiate_checkout: 'value_per_initiate_checkout',
    total_initiate_checkout_value: 'total_initiate_checkout_value',
    // Leads
    sales_lead: 'sales_lead',
    cost_per_sales_lead: 'cost_per_sales_lead',
    sales_lead_rate: 'sales_lead_rate',
    total_sales_lead: 'total_sales_lead',
    cost_per_total_sales_lead: 'cost_per_total_sales_lead',
    value_per_total_sales_lead: 'value_per_total_sales_lead',
    total_sales_lead_value: 'total_sales_lead_value',
    // Trial
    start_trial: 'start_trial',
    cost_per_start_trial: 'cost_per_start_trial',
    start_trial_rate: 'start_trial_rate',
    total_start_trial: 'total_start_trial',
    cost_per_total_start_trial: 'cost_per_total_start_trial',
    // Subscribe
    subscribe: 'subscribe',
    cost_per_subscribe: 'cost_per_subscribe',
    subscribe_rate: 'subscribe_rate',
    total_subscribe: 'total_subscribe',
    cost_per_total_subscribe: 'cost_per_total_subscribe',
    value_per_total_subscribe: 'value_per_total_subscribe',
    total_subscribe_value: 'total_subscribe_value',
    // Web subscribe
    on_web_subscribe: 'on_web_subscribe',
    cost_per_on_web_subscribe: 'cost_per_on_web_subscribe',
    on_web_subscribe_per_click: 'on_web_subscribe_per_click',
    value_per_on_web_subscribe: 'value_per_on_web_subscribe',
    total_on_web_subscribe_value: 'total_on_web_subscribe_value',
    // Web order
    on_web_order: 'on_web_order',
    cost_per_on_web_order: 'cost_per_on_web_order',
    on_web_order_rate: 'on_web_order_rate',
    value_per_on_web_order: 'value_per_on_web_order',
    total_on_web_order_value: 'total_on_web_order_value',
};
export const INSIGHTS_TIKTOK_BASIC_METRICS = {
    spend: 'spend',
    billed_cost: 'billed_cost',
    cash_spend: 'cash_spend',
    voucher_spend: 'voucher_spend',
    cpc: 'cpc',
    cpm: 'cpm',
    impressions: 'impressions',
    gross_impressions: 'gross_impressions',
    clicks: 'clicks',
    ctr: 'ctr',
    reach: 'reach',
    cost_per_1000_reached: 'cost_per_1000_reached',
    frequency: 'frequency',
    conversion: 'conversion',
    cost_per_conversion: 'cost_per_conversion',
    conversion_rate: 'conversion_rate',
    conversion_rate_v2: 'conversion_rate_v2',
    real_time_conversion: 'real_time_conversion',
    real_time_cost_per_conversion: 'real_time_cost_per_conversion',
    real_time_conversion_rate: 'real_time_conversion_rate',
    real_time_conversion_rate_v2: 'real_time_conversion_rate_v2',
    result: 'result',
    cost_per_result: 'cost_per_result',
    result_rate: 'result_rate',
    real_time_result: 'real_time_result',
    real_time_cost_per_result: 'real_time_cost_per_result',
    real_time_result_rate: 'real_time_result_rate',
    secondary_goal_result: 'secondary_goal_result',
    cost_per_secondary_goal_result: 'cost_per_secondary_goal_result',
    secondary_goal_result_rate: 'secondary_goal_result_rate',
};
export const INSIGHTS_TIKTOK_VIDEO_PLAY_METRICS = {
    video_play_actions: 'video_play_actions',
    video_watched_2s: 'video_watched_2s',
    video_watched_6s: 'video_watched_6s',
    engaged_view: 'engaged_view',
    engaged_view_15s: 'engaged_view_15s',
    video_views_p25: 'video_views_p25',
    video_views_p50: 'video_views_p50',
    video_views_p75: 'video_views_p75',
    video_views_p100: 'video_views_p100',
    average_video_play: 'average_video_play',
    average_video_play_per_user: 'average_video_play_per_user',
};
export const INSIGHTS_TIKTOK_ENGAGEMENT_METRICS = {
    engagements: 'engagements',
    engagement_rate: 'engagement_rate',
    follows: 'follows',
    likes: 'likes',
    comments: 'comments',
    shares: 'shares',
    profile_visits: 'profile_visits',
    profile_visits_rate: 'profile_visits_rate',
    clicks_on_music_disc: 'clicks_on_music_disc',
    duet_clicks: 'duet_clicks',
    stitch_clicks: 'stitch_clicks',
    sound_usage_clicks: 'sound_usage_clicks',
    anchor_clicks: 'anchor_clicks',
    anchor_click_rate: 'anchor_click_rate',
    clicks_on_hashtag_challenge: 'clicks_on_hashtag_challenge',
    ix_page_duration_avg: 'ix_page_duration_avg',
    ix_page_viewrate_avg: 'ix_page_viewrate_avg',
    ix_video_views: 'ix_video_views',
    ix_video_views_p25: 'ix_video_views_p25',
    ix_video_views_p50: 'ix_video_views_p50',
    ix_video_views_p75: 'ix_video_views_p75',
    ix_video_views_p100: 'ix_video_views_p100',
    ix_average_video_play: 'ix_average_video_play',
    // single_image_impressions: 'single_image_impressions',
    // single_image_impression_rate: 'single_image_impression_rate',
    // single_image_ctr: 'single_image_ctr',
    tt_playlist_visit: 'tt_playlist_visit',
    tt_playlist_visit_rate: 'tt_playlist_visit_rate',
};
export const INSIGHTS_TIKTOK_ATTRIBUTION_METRICS = {
    vta_complete_payment: 'vta_complete_payment',
    cost_per_vta_payments_completed: 'cost_per_vta_payments_completed',
    vta_complete_payment_value: 'vta_complete_payment_value',
    vta_complete_payment_roas: 'vta_complete_payment_roas',
};
export const INSIGHTS_TIKTOK_PAGE_EVENT_METRICS = {
    // Landing Page View
    total_landing_page_view: 'total_landing_page_view',
    cost_per_landing_page_view: 'cost_per_landing_page_view',
    landing_page_view_rate: 'landing_page_view_rate',
    // Search
    page_event_search: 'page_event_search',
    cost_per_page_event_search: 'cost_per_page_event_search',
    page_event_search_rate: 'page_event_search_rate',
    value_per_page_event_search: 'value_per_page_event_search',
    total_page_event_search_value: 'total_page_event_search_value',
    // Form
    form: 'form',
    cost_per_form: 'cost_per_form',
    form_rate: 'form_rate',
    value_per_form: 'value_per_form',
    total_form_value: 'total_form_value',
    // Download
    download_start: 'download_start',
    cost_per_download_start: 'cost_per_download_start',
    download_start_rate: 'download_start_rate',
    value_per_download_start: 'value_per_download_start',
    total_download_start_value: 'total_download_start_value',
    // Add to wishlist
    on_web_add_to_wishlist: 'on_web_add_to_wishlist',
    cost_per_on_web_add_to_wishlist: 'cost_per_on_web_add_to_wishlist',
    on_web_add_to_wishlist_per_click: 'on_web_add_to_wishlist_per_click',
    value_per_on_web_add_to_wishlist: 'value_per_on_web_add_to_wishlist',
    total_on_web_add_to_wishlist_value: 'total_on_web_add_to_wishlist_value',
    // Billing
    add_billing: 'add_billing',
    cost_per_add_billing: 'cost_per_add_billing',
    add_billing_rate: 'add_billing_rate',
    value_per_add_billing: 'value_per_add_billing',
    total_add_billing_value: 'total_add_billing_value',
};
export const INSIGHTS_TIKTOK_ONSITE_METRICS = {
    onsite_add_to_wishlist: 'onsite_add_to_wishlist',
    cost_per_onsite_add_to_wishlist: 'cost_per_onsite_add_to_wishlist',
    onsite_add_to_wishlist_rate: 'onsite_add_to_wishlist_rate',
    value_per_onsite_add_to_wishlist: 'value_per_onsite_add_to_wishlist',
    total_onsite_add_to_wishlist_value: 'total_onsite_add_to_wishlist_value',
    onsite_add_billing: 'onsite_add_billing',
    cost_per_onsite_add_billing: 'cost_per_onsite_add_billing',
    onsite_add_billing_rate: 'onsite_add_billing_rate',
    value_per_onsite_add_billing: 'value_per_onsite_add_billing',
    total_onsite_add_billing_value: 'total_onsite_add_billing_value',
    onsite_form: 'onsite_form',
    cost_per_onsite_form: 'cost_per_onsite_form',
    onsite_form_rate: 'onsite_form_rate',
    value_per_onsite_form: 'value_per_onsite_form',
    total_onsite_form_value: 'total_onsite_form_value',
    onsite_download_start: 'onsite_download_start',
    cost_per_onsite_download_start: 'cost_per_onsite_download_start',
    onsite_download_start_rate: 'onsite_download_start_rate',
    onsite_destination_visits: 'onsite_destination_visits',
    cost_per_onsite_destination_visit: 'cost_per_onsite_destination_visit',
    onsite_destination_visit_rate: 'onsite_destination_visit_rate',
    ix_page_view_count: 'ix_page_view_count',
    cost_per_ix_page_view_count: 'cost_per_ix_page_view_count',
    ix_page_view_count_rate: 'ix_page_view_count_rate',
    ix_button_click_count: 'ix_button_click_count',
    cost_per_ix_button_click_count: 'cost_per_ix_button_click_count',
    ix_button_click_count_rate: 'ix_button_click_count_rate',
    ix_product_click_count: 'ix_product_click_count',
    cost_per_ix_product_click_count: 'cost_per_ix_product_click_count',
    ix_product_click_count_rate: 'ix_product_click_count_rate',
};
export const INSIGHTS_TIKTOK_OFFLINE_METRICS = {
    offline_shopping_events: 'offline_shopping_events',
    cost_per_offline_shopping_event: 'cost_per_offline_shopping_event',
    offline_shopping_event_rate: 'offline_shopping_event_rate',
    value_per_offline_shopping_event: 'value_per_offline_shopping_event',
    offline_shopping_events_value: 'offline_shopping_events_value',
    offline_shopping_events_roas: 'offline_shopping_events_roas',
    offline_contact_events: 'offline_contact_events',
    cost_per_offline_contact_event: 'cost_per_offline_contact_event',
    offline_contact_event_rate: 'offline_contact_event_rate',
    value_per_offline_contact_event: 'value_per_offline_contact_event',
    offline_contact_events_value: 'offline_contact_events_value',
    offline_subscribe_events: 'offline_subscribe_events',
    cost_per_offline_subscribe_event: 'cost_per_offline_subscribe_event',
    offline_subscribe_event_rate: 'offline_subscribe_event_rate',
    value_per_offline_subscribe_event: 'value_per_offline_subscribe_event',
    offline_subscribe_events_value: 'offline_subscribe_events_value',
    offline_form_events: 'offline_form_events',
    cost_per_offline_form_event: 'cost_per_offline_form_event',
    offline_form_event_rate: 'offline_form_event_rate',
    value_per_offline_form_event: 'value_per_offline_form_event',
    offline_form_events_value: 'offline_form_events_value',
    offline_add_payment_info_events: 'offline_add_payment_info_events',
    cost_per_offline_add_payment_info_event: 'cost_per_offline_add_payment_info_event',
    offline_add_payment_info_event_rate: 'offline_add_payment_info_event_rate',
    value_per_offline_add_payment_info_event: 'value_per_offline_add_payment_info_event',
    offline_add_payment_info_events_value: 'offline_add_payment_info_events_value',
    offline_add_to_cart_events: 'offline_add_to_cart_events',
    cost_per_offline_add_to_cart_event: 'cost_per_offline_add_to_cart_event',
    offline_add_to_cart_event_rate: 'offline_add_to_cart_event_rate',
    value_per_offline_add_to_cart_event: 'value_per_offline_add_to_cart_event',
    offline_add_to_cart_events_value: 'offline_add_to_cart_events_value',
    offline_add_to_wishlist_events: 'offline_add_to_wishlist_events',
    cost_per_offline_add_to_wishlist_event: 'cost_per_offline_add_to_wishlist_event',
    offline_add_to_wishlist_event_rate: 'offline_add_to_wishlist_event_rate',
    value_per_offline_add_to_wishlist_event: 'value_per_offline_add_to_wishlist_event',
    offline_add_to_wishlist_events_value: 'offline_add_to_wishlist_events_value',
    offline_click_button_events: 'offline_click_button_events',
    cost_per_offline_click_button_event: 'cost_per_offline_click_button_event',
    offline_click_button_event_rate: 'offline_click_button_event_rate',
    value_per_offline_click_button_event: 'value_per_offline_click_button_event',
    offline_click_button_events_value: 'offline_click_button_events_value',
    offline_complete_registration_events: 'offline_complete_registration_events',
    cost_per_offline_complete_registration_event: 'cost_per_offline_complete_registration_event',
    offline_complete_registration_event_rate: 'offline_complete_registration_event_rate',
    value_per_offline_complete_registration_event: 'value_per_offline_complete_registration_event',
    offline_complete_registration_events_value: 'offline_complete_registration_events_value',
    offline_download_events: 'offline_download_events',
    cost_per_offline_download_event: 'cost_per_offline_download_event',
    offline_download_event_rate: 'offline_download_event_rate',
    value_per_offline_download_event: 'value_per_offline_download_event',
    offline_download_events_value: 'offline_download_events_value',
    offline_initiate_checkout_events: 'offline_initiate_checkout_events',
    cost_per_offline_initiate_checkout_event: 'cost_per_offline_initiate_checkout_event',
    offline_initiate_checkout_event_rate: 'offline_initiate_checkout_event_rate',
    value_per_offline_initiate_checkout_event: 'value_per_offline_initiate_checkout_event',
    offline_initiate_checkout_events_value: 'offline_initiate_checkout_events_value',
    offline_place_order_events: 'offline_place_order_events',
    cost_per_offline_place_order_event: 'cost_per_offline_place_order_event',
    offline_place_order_event_rate: 'offline_place_order_event_rate',
    value_per_offline_place_order_event: 'value_per_offline_place_order_event',
    offline_place_order_events_value: 'offline_place_order_events_value',
    offline_search_events: 'offline_search_events',
    cost_per_offline_search_event: 'cost_per_offline_search_event',
    offline_search_event_rate: 'offline_search_event_rate',
    value_per_offline_search_event: 'value_per_offline_search_event',
    offline_search_events_value: 'offline_search_events_value',
    offline_view_content_events: 'offline_view_content_events',
    cost_per_offline_view_content_event: 'cost_per_offline_view_content_event',
    offline_view_content_event_rate: 'offline_view_content_event_rate',
    value_per_offline_view_content_event: 'value_per_offline_view_content_event',
    offline_view_content_events_value: 'offline_view_content_events_value',
};
export const INSIGHTS_TIKTOK_SKAN_METRICS = {
    skan_result: 'skan_result',
    skan_cost_per_result: 'skan_cost_per_result',
    skan_result_rate: 'skan_result_rate',
    skan_conversion: 'skan_conversion',
    skan_cost_per_conversion: 'skan_cost_per_conversion',
    skan_conversion_rate: 'skan_conversion_rate',
    skan_conversion_rate_v2: 'skan_conversion_rate_v2',
    skan_click_time_conversion: 'skan_click_time_conversion',
    skan_click_time_cost_per_conversion: 'skan_click_time_cost_per_conversion',
    skan_click_time_conversion_rate: 'skan_click_time_conversion_rate',
    skan_click_time_conversion_rate_v2: 'skan_click_time_conversion_rate_v2',
    skan_app_install: 'skan_app_install',
    skan_cost_per_app_install: 'skan_cost_per_app_install',
    skan_app_install_withheld: 'skan_app_install_withheld',
    skan_registration: 'skan_registration',
    skan_cost_per_registration: 'skan_cost_per_registration',
    skan_registration_rate: 'skan_registration_rate',
    skan_total_registration: 'skan_total_registration',
    skan_cost_per_total_registration: 'skan_cost_per_total_registration',
    skan_purchase: 'skan_purchase',
    skan_cost_per_purchase: 'skan_cost_per_purchase',
    skan_purchase_rate: 'skan_purchase_rate',
    skan_total_purchase: 'skan_total_purchase',
    skan_cost_per_total_purchase: 'skan_cost_per_total_purchase',
    skan_total_purchase_value: 'skan_total_purchase_value',
    skan_total_repetitive_active_pay_roas: 'skan_total_repetitive_active_pay_roas',
    skan_add_to_cart: 'skan_add_to_cart',
    skan_cost_per_add_to_cart: 'skan_cost_per_add_to_cart',
    skan_add_to_cart_rate: 'skan_add_to_cart_rate',
    skan_total_add_to_cart: 'skan_total_add_to_cart',
    skan_cost_per_total_add_to_cart: 'skan_cost_per_total_add_to_cart',
    skan_total_add_to_cart_value: 'skan_total_add_to_cart_value',
    skan_checkout: 'skan_checkout',
    skan_cost_per_checkout: 'skan_cost_per_checkout',
    skan_checkout_rate: 'skan_checkout_rate',
    skan_total_checkout: 'skan_total_checkout',
    skan_cost_per_total_checkout: 'skan_cost_per_total_checkout',
    skan_total_checkout_value: 'skan_total_checkout_value',
    skan_view_content: 'skan_view_content',
    skan_cost_per_view_content: 'skan_cost_per_view_content',
    skan_view_content_rate: 'skan_view_content_rate',
    skan_total_view_content: 'skan_total_view_content',
    skan_cost_per_total_view_content: 'skan_cost_per_total_view_content',
    skan_total_view_content_value: 'skan_total_view_content_value',
    skan_add_payment_info: 'skan_add_payment_info',
    skan_cost_per_add_payment_info: 'skan_cost_per_add_payment_info',
    skan_add_payment_info_rate: 'skan_add_payment_info_rate',
    skan_total_add_payment_info: 'skan_total_add_payment_info',
    skan_cost_total_add_payment_info: 'skan_cost_total_add_payment_info',
    skan_add_to_wishlist: 'skan_add_to_wishlist',
    skan_cost_per_add_to_wishlist: 'skan_cost_per_add_to_wishlist',
    skan_add_to_wishlist_rate: 'skan_add_to_wishlist_rate',
    skan_total_add_to_wishlist: 'skan_total_add_to_wishlist',
    skan_cost_per_total_add_to_wishlist: 'skan_cost_per_total_add_to_wishlist',
    skan_total_add_to_wishlist_value: 'skan_total_add_to_wishlist_value',
    skan_launch_app: 'skan_launch_app',
    skan_cost_per_launch_app: 'skan_cost_per_launch_app',
    skan_launch_app_rate: 'skan_launch_app_rate',
    skan_total_launch_app: 'skan_total_launch_app',
    skan_cost_per_total_launch_app: 'skan_cost_per_total_launch_app',
    skan_total_complete_tutorial: 'skan_total_complete_tutorial',
    skan_cost_per_total_complete_tutorial: 'skan_cost_per_total_complete_tutorial',
    skan_complete_tutorial: 'skan_complete_tutorial',
    skan_cost_per_complete_tutorial: 'skan_cost_per_complete_tutorial',
    skan_complete_tutorial_rate: 'skan_complete_tutorial_rate',
    skan_total_complete_tutorial_value: 'skan_total_complete_tutorial_value',
    skan_create_group: 'skan_create_group',
    skan_cost_per_create_group: 'skan_cost_per_create_group',
    skan_create_group_rate: 'skan_create_group_rate',
    skan_total_create_group: 'skan_total_create_group',
    skan_cost_per_total_create_group: 'skan_cost_per_total_create_group',
    skan_total_create_group_value: 'skan_total_create_group_value',
    skan_join_group: 'skan_join_group',
    skan_cost_per_join_group: 'skan_cost_per_join_group',
    skan_join_group_rate: 'skan_join_group_rate',
    skan_total_join_group: 'skan_total_join_group',
    skan_cost_per_total_join_group: 'skan_cost_per_total_join_group',
    skan_total_join_group_value: 'skan_total_join_group_value',
    skan_create_gamerole: 'skan_create_gamerole',
    skan_cost_per_create_gamerole: 'skan_cost_per_create_gamerole',
    skan_create_gamerole_rate: 'skan_create_gamerole_rate',
    skan_total_create_gamerole: 'skan_total_create_gamerole',
    skan_cost_per_total_create_gamerole: 'skan_cost_per_total_create_gamerole',
    skan_total_create_gamerole_value: 'skan_total_create_gamerole_value',
    skan_spend_credits: 'skan_spend_credits',
    skan_cost_per_spend_credits: 'skan_cost_per_spend_credits',
    skan_spend_credits_rate: 'skan_spend_credits_rate',
    skan_total_spend_credits: 'skan_total_spend_credits',
    skan_cost_per_total_spend_credits: 'skan_cost_per_total_spend_credits',
    skan_total_spend_credits_value: 'skan_total_spend_credits_value',
    skan_achieve_level: 'skan_achieve_level',
    skan_cost_per_achieve_level: 'skan_cost_per_achieve_level',
    skan_achieve_level_rate: 'skan_achieve_level_rate',
    skan_total_achieve_level: 'skan_total_achieve_level',
    skan_cost_per_total_achieve_level: 'skan_cost_per_total_achieve_level',
    skan_total_achieve_level_value: 'skan_total_achieve_level_value',
    skan_unlock_achievement: 'skan_unlock_achievement',
    skan_cost_per_unlock_achievement: 'skan_cost_per_unlock_achievement',
    skan_unlock_achievement_rate: 'skan_unlock_achievement_rate',
    skan_total_unlock_achievement: 'skan_total_unlock_achievement',
    skan_cost_per_total_unlock_achievement: 'skan_cost_per_total_unlock_achievement',
    skan_total_unlock_achievement_value: 'skan_total_unlock_achievement_value',
    skan_sales_lead: 'skan_sales_lead',
    skan_cost_per_sales_lead: 'skan_cost_per_sales_lead',
    skan_sales_lead_rate: 'skan_sales_lead_rate',
    skan_total_sales_lead: 'skan_total_sales_lead',
    skan_cost_per_total_sales_lead: 'skan_cost_per_total_sales_lead',
    skan_total_sales_lead_value: 'skan_total_sales_lead_value',
    skan_in_app_ad_click: 'skan_in_app_ad_click',
    skan_cost_per_in_app_ad_click: 'skan_cost_per_in_app_ad_click',
    skan_in_app_ad_click_rate: 'skan_in_app_ad_click_rate',
    skan_total_in_app_ad_click: 'skan_total_in_app_ad_click',
    skan_cost_per_total_in_app_ad_click: 'skan_cost_per_total_in_app_ad_click',
    skan_total_in_app_ad_click_value: 'skan_total_in_app_ad_click_value',
    skan_in_app_ad_impr: 'skan_in_app_ad_impr',
    skan_cost_per_in_app_ad_impr: 'skan_cost_per_in_app_ad_impr',
    skan_in_app_ad_impr_rate: 'skan_in_app_ad_impr_rate',
    skan_total_in_app_ad_impr: 'skan_total_in_app_ad_impr',
    skan_cost_per_total_in_app_ad_impr: 'skan_cost_per_total_in_app_ad_impr',
    skan_total_in_app_ad_impr_value: 'skan_total_in_app_ad_impr_value',
    skan_loan_apply: 'skan_loan_apply',
    skan_cost_per_loan_apply: 'skan_cost_per_loan_apply',
    skan_loan_apply_rate: 'skan_loan_apply_rate',
    skan_total_loan_apply: 'skan_total_loan_apply',
    skan_cost_per_total_loan_apply: 'skan_cost_per_total_loan_apply',
    skan_loan_credit: 'skan_loan_credit',
    skan_cost_per_loan_credit: 'skan_cost_per_loan_credit',
    skan_loan_credit_rate: 'skan_loan_credit_rate',
    skan_total_loan_credit: 'skan_total_loan_credit',
    skan_cost_per_total_loan_credit: 'skan_cost_per_total_loan_credit',
    skan_loan_disbursement: 'skan_loan_disbursement',
    skan_cost_per_loan_disbursement: 'skan_cost_per_loan_disbursement',
    skan_loan_disbursement_rate: 'skan_loan_disbursement_rate',
    skan_total_loan_disbursement: 'skan_total_loan_disbursement',
    skan_cost_per_total_loan_disbursement: 'skan_cost_per_total_loan_disbursement',
    skan_login: 'skan_login',
    skan_cost_per_login: 'skan_cost_per_login',
    skan_login_rate: 'skan_login_rate',
    skan_total_login: 'skan_total_login',
    skan_cost_per_total_login: 'skan_cost_per_total_login',
    skan_ratings: 'skan_ratings',
    skan_cost_per_ratings: 'skan_cost_per_ratings',
    skan_ratings_rate: 'skan_ratings_rate',
    skan_total_ratings: 'skan_total_ratings',
    skan_cost_per_total_ratings: 'skan_cost_per_total_ratings',
    skan_total_ratings_value: 'skan_total_ratings_value',
    skan_search: 'skan_search',
    skan_cost_per_search: 'skan_cost_per_search',
    skan_search_rate: 'skan_search_rate',
    skan_total_search: 'skan_total_search',
    skan_cost_per_total_search: 'skan_cost_per_total_search',
    skan_start_trial: 'skan_start_trial',
    skan_cost_per_start_trial: 'skan_cost_per_start_trial',
    skan_start_trial_rate: 'skan_start_trial_rate',
    skan_total_start_trial: 'skan_total_start_trial',
    skan_cost_per_total_start_trial: 'skan_cost_per_total_start_trial',
    skan_subscribe: 'skan_subscribe',
    skan_cost_per_subscribe: 'skan_cost_per_subscribe',
    skan_subscribe_rate: 'skan_subscribe_rate',
    skan_total_subscribe: 'skan_total_subscribe',
    skan_cost_per_total_subscribe: 'skan_cost_per_total_subscribe',
    skan_total_subscribe_value: 'skan_total_subscribe_value',
    skan_vta_conversion: 'skan_vta_conversion',
    skan_cost_per_vta_conversion: 'skan_cost_per_vta_conversion',
    skan_vta_app_install: 'skan_vta_app_install',
    skan_cost_per_vta_app_install: 'skan_cost_per_vta_app_install',
    skan_vta_registration: 'skan_vta_registration',
    skan_cost_per_vta_registration: 'skan_cost_per_vta_registration',
    skan_vta_purchase: 'skan_vta_purchase',
    skan_cost_per_vta_purchase: 'skan_cost_per_vta_purchase',
    skan_cta_conversion: 'skan_cta_conversion',
    skan_cost_per_cta_conversion: 'skan_cost_per_cta_conversion',
    skan_cta_app_install: 'skan_cta_app_install',
    skan_cost_per_cta_app_install: 'skan_cost_per_cta_app_install',
    skan_cta_registration: 'skan_cta_registration',
    skan_cost_per_cta_registration: 'skan_cost_per_cta_registration',
    skan_cta_purchase: 'skan_cta_purchase',
    skan_cost_per_cta_purchase: 'skan_cost_per_cta_purchase',
};
export const INSIGHTS_TIKTOK_WIZARD_SCORES = {
    wizardHookScore: 'wizardHookScore',
    wizardHoldScore: 'wizardHoldScore',
    wizardClickScore: 'wizardClickScore',
    wizardBuyScore: 'wizardBuyScore',
};
export const INSIGHTS_TIKTOK_SYNTHETIC_METRICS = {
    // Video engagement metrics
    thumbstopRatio: 'thumbstopRatio',
    holdRate: 'holdRate',
    thruplayRate: 'thruplayRate', // ADDED: percentage of impressions resulting in 15s views
    holdplayRate: 'holdplayRate', // ADDED: renamed version of holdRate for consistency
    videoCompletionRate: 'videoCompletionRate',
    firstFrameRetention: 'firstFrameRetention',
    averageOrderValue: 'averageOrderValue',
    // Video analysis metrics
    videoViewRate: 'videoViewRate',
    p25ToP50DropoffRate: 'p25ToP50DropoffRate',
    p50ToP75DropoffRate: 'p50ToP75DropoffRate',
    p75ToP100DropoffRate: 'p75ToP100DropoffRate',
    // Engagement metrics
    engagementPerImpression: 'engagementPerImpression',
    // Conversion metrics
    clicksToConversionRatio: 'clicksToConversionRatio',
    costPerEngagement: 'costPerEngagement',
    costPerEngagedView: 'costPerEngagedView',
    costPer15SecondEngagedView: 'costPer15SecondEngagedView',
    costPerThruplay: 'costPerThruplay', // ADDED: cost per 15s view
    costPerHoldplay: 'costPerHoldplay',
    // Wizard score equivalents (mapping to your original system)
    // Other engagement metrics
    thruplayClickThroughRate: 'thruplayClickThroughRate',
    video15Sec2SecVideoRetention: 'video15Sec2SecVideoRetention',
    clickToPurchaseRatio: 'clickToPurchaseRatio',
    spendPercentage: 'spendPercentage',
    purchaseValuePercentage: 'purchaseValuePercentage',
};
export const INSIGHTS_TIKTOK_TIME_SERIES_ALL_METRICS_AND_FIELDS = {
    ...INSIGHTS_TIKTOK_ATTRIBUTE_FIELDS,
    ...INSIGHTS_TIKTOK_BASIC_METRICS,
    ...INSIGHTS_TIKTOK_VIDEO_PLAY_METRICS,
    ...INSIGHTS_TIKTOK_ENGAGEMENT_METRICS,
    ...INSIGHTS_TIKTOK_ATTRIBUTION_METRICS,
    ...INSIGHTS_TIKTOK_PAGE_EVENT_METRICS,
    ...INSIGHTS_TIKTOK_CONVERSION_METRICS,
    ...INSIGHTS_TIKTOK_APP_METRICS,
    ...INSIGHTS_TIKTOK_GAMING_METRICS,
    ...INSIGHTS_TIKTOK_SOCIAL_METRICS,
    ...INSIGHTS_TIKTOK_IN_APP_AD_METRICS,
    ...INSIGHTS_TIKTOK_FINANCE_METRICS,
    ...INSIGHTS_TIKTOK_CUSTOM_EVENT_METRICS,
    ...INSIGHTS_TIKTOK_SYNTHETIC_METRICS,
    ...INSIGHTS_TIKTOK_ONSITE_METRICS,
    ...INSIGHTS_TIKTOK_OFFLINE_METRICS,
    ...INSIGHTS_TIKTOK_SKAN_METRICS,
    ...INSIGHTS_TIK_TOK_FILTERABLE_AD_ATTRIBUTES,
    ...INSIGHTS_TIK_TOK_FILTERABLE_AD_ATTRIBUTES,
};
export const INSIGHTS_TIKTOK_TIME_SERIES_ALL_METRICS_AND_FIELDS_LIST = Object.keys(INSIGHTS_TIKTOK_TIME_SERIES_ALL_METRICS_AND_FIELDS);
export function isInsightsTikTokFieldTimeSeries(field) {
    if (field in INSIGHTS_TIKTOK_TIME_SERIES_ALL_METRICS_AND_FIELDS) {
        return true;
    }
    return false;
}
export function isInsightsTikTokTimeSeriesFieldNumeric(field) {
    if (!(field in INSIGHTS_TIKTOK_ATTRIBUTE_FIELDS)) {
        return true;
    }
    return false;
}
export function isInsightsTikTokTimeSeriesFieldEnumerable(field) {
    if (field === INSIGHTS_TIKTOK_ATTRIBUTE_FIELDS.app_promotion_type)
        return true;
    return false;
}
export const INSIGHTS_TIKTOK_MAGICBRIEF_COMPUTED_METRICS = {
    spend_percentage: 'spend_percentage',
    engagement_rate: 'engagement_rate',
};
export const INSIGHTS_TIKTOK_ATTRIBUTE_GLOSSARY = {
    advertiser_name: {
        label: 'Advertiser Name',
        formatting: 'text',
    },
    advertiser_id: {
        label: 'Advertiser ID',
        formatting: 'text',
    },
    campaign_name: {
        label: 'Campaign Name',
        formatting: 'text',
    },
    campaign_id: {
        label: 'Campaign ID',
        formatting: 'text',
    },
    objective_type: {
        label: 'Objective Type',
        formatting: 'text',
    },
    split_test: {
        label: 'Split Test',
        formatting: 'text',
    },
    campaign_budget: {
        label: 'Campaign Budget',
        formatting: 'text',
    },
    campaign_dedicate_type: {
        label: 'Campaign Dedicate Type',
        formatting: 'text',
    },
    app_promotion_type: {
        label: 'App Promotion Type',
        formatting: 'text',
    },
    adgroup_name: {
        label: 'Ad Group Name',
        formatting: 'text',
    },
    adgroup_id: {
        label: 'Ad Group ID',
        formatting: 'text',
    },
    placement_type: {
        label: 'Placement Type',
        formatting: 'text',
    },
    promotion_type: {
        label: 'Promotion Type',
        formatting: 'text',
    },
    opt_status: {
        label: 'Opt Status',
        formatting: 'text',
    },
    adgroup_download_url: {
        label: 'Ad Group Download URL',
        formatting: 'text',
    },
    profile_image: {
        label: 'Profile Image',
        formatting: 'text',
    },
    dpa_target_audience_type: {
        label: 'DPA Target Audience Type',
        formatting: 'text',
    },
    budget: {
        label: 'Budget',
        formatting: 'text',
    },
    smart_target: {
        label: 'Smart Target',
        formatting: 'text',
    },
    /** @deprecated */
    pricing_category: {
        label: 'Pricing Category',
        formatting: 'text',
    },
    billing_event: {
        label: 'Billing EVent',
        formatting: 'text',
    },
    bid_strategy: {
        label: 'Bid Strategy',
        formatting: 'text',
    },
    bid: {
        label: 'Bid',
        formatting: 'text',
    },
    bid_secondary_goal: {
        label: 'Bid Secondary Goal',
        formatting: 'text',
    },
    aeo_type: {
        label: 'AEO Type',
        formatting: 'text',
    },
    ad_name: {
        label: 'Ad Name',
        formatting: 'text',
    },
    ad_id: {
        label: 'Ad ID',
        formatting: 'text',
    },
    ad_text: {
        label: 'Ad Text',
        formatting: 'text',
    },
    call_to_action: {
        label: 'Call To Action',
        formatting: 'text',
    },
    ad_profile_image: {
        label: 'Ad Profile Image',
        formatting: 'text',
    },
    ad_url: {
        label: 'Ad URL',
        formatting: 'text',
    },
    tt_app_id: {
        label: 'TikTok App ID',
        formatting: 'text',
    },
    tt_app_name: {
        label: 'TikTok App Name',
        formatting: 'text',
    },
    mobile_app_id: {
        label: 'Mobile App ID',
        formatting: 'text',
    },
    image_mode: {
        label: 'Image Mode',
        formatting: 'text',
    },
    currency: {
        label: 'Currency',
        formatting: 'text',
    },
    is_aco: {
        label: 'ACO',
        formatting: 'text',
    },
    is_smart_creative: {
        label: 'Smart Creative',
        formatting: 'text',
    },
    device_brand_name: {
        label: 'Device Brand Name',
        formatting: 'text',
    },
    behavior_name: {
        label: 'Behaviour Name',
        formatting: 'text',
    },
    action_category: {
        label: 'Action Category',
        formatting: 'text',
    },
    action_scene: {
        label: 'Action Scene',
        formatting: 'text',
    },
    user_action: {
        label: 'User Action',
        formatting: 'text',
    },
    action_period: {
        label: 'Action Period',
        formatting: 'text',
    },
    rf_campaign_type: {
        label: 'RF Campaign Type',
        formatting: 'text',
    },
    delivery_type: {
        label: 'Delivery Type',
        formatting: 'text',
    },
    adgroup_display_name: {
        label: 'Ad Group Display Name',
        formatting: 'text',
    },
    adgroup_schedule: {
        label: 'Ad Group Schedule',
        formatting: 'text',
    },
    optimization_preference: {
        label: 'Optimization Preference',
        formatting: 'text',
    },
    image_info: {
        label: 'Image Info',
        formatting: 'text',
    },
    ad_display_name: {
        label: 'Ad Display Name',
        formatting: 'text',
    },
    identity_type: {
        label: 'Identity Type',
        formatting: 'text',
    },
};
export const INSIGHTS_TIKTOK_AD_ATTRIBUTE_GLOSSARY = {
    campaign_name: { formatting: 'text', definition: '', label: 'Campaign Name' },
    adgroup_name: { formatting: 'text', definition: '', label: 'Ad Group Name' },
    ad_name: { formatting: 'text', definition: '', label: 'Ad Name' },
    ad_format: {
        formatting: 'text',
        definition: '',
        label: 'Ad Format',
        enumerable: {
            SINGLE_IMAGE: 'Single Image',
            SINGLE_VIDEO: 'Single Video',
            CAROUSEL_ADS: 'Non-VSA Carousel Ads',
            CATALOG_CAROUSEL: 'VSA Carousel Ads',
        },
    },
    landing_page_url: {
        formatting: 'text',
        definition: '',
        label: 'Landing Page URL',
    },
};
export const INSIGHTS_TIKTOK_DERIVED_VALUES_GLOSSARY = {
    delivery: {
        formatting: 'text',
        definition: '',
        label: 'Delivery',
        enumerable: {
            ACTIVE: 'Active',
            INACTIVE: 'Inactive',
        },
    },
};
export const INSIGHTS_TIKTOK_METRIC_GLOSSARY = {
    // Basic Metrics
    spend: {
        label: 'Spend',
        header: 'Basic Metrics',
        higherIs: 'neutral',
        accumulation: 'sum',
        definition: '',
        formatting: 'currency',
    },
    billed_cost: {
        label: 'Billed Cost',
        header: 'Basic Metrics',
        higherIs: 'neutral',
        accumulation: 'sum',
        definition: '',
        formatting: 'currency',
    },
    cash_spend: {
        label: 'Cash Spend',
        header: 'Basic Metrics',
        higherIs: 'neutral',
        accumulation: 'sum',
        definition: '',
        formatting: 'currency',
    },
    voucher_spend: {
        label: 'Voucher Spend',
        header: 'Basic Metrics',
        higherIs: 'neutral',
        accumulation: 'sum',
        definition: '',
        formatting: 'currency',
    },
    cpc: {
        label: 'CPC',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    cpm: {
        label: 'CPM',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    impressions: {
        label: 'Impressions',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    gross_impressions: {
        label: 'Gross Impressions',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    clicks: {
        label: 'Clicks',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    ctr: {
        label: 'CTR',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    reach: {
        label: 'Reach',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
        synonyms: 'raw',
    },
    cost_per_1000_reached: {
        label: 'Cost Per 1,000 Reached',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    frequency: {
        label: 'Frequency',
        header: 'Basic Metrics',
        higherIs: 'neutral',
        accumulation: 'sum',
        definition: '',
        synonyms: 'people,saw',
        formatting: 'numeric',
    },
    conversion: {
        label: 'Conversions',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    cost_per_conversion: {
        label: 'Cost Per Conversion',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    conversion_rate: {
        label: 'Conversion Rate',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    conversion_rate_v2: {
        label: 'Conversion Rate V2',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    real_time_conversion: {
        label: 'Real-Time Conversions',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    real_time_cost_per_conversion: {
        label: 'Real-Time Cost Per Conversion',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    real_time_conversion_rate: {
        label: 'Real-Time Conversion Rate',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    real_time_conversion_rate_v2: {
        label: 'Real-Time Conversion Rate V2',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    result: {
        label: 'Results',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    cost_per_result: {
        label: 'Cost Per Result',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    result_rate: {
        label: 'Result Rate',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    real_time_result: {
        label: 'Real-Time Results',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    real_time_cost_per_result: {
        label: 'Real-Time Cost Per Result',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    real_time_result_rate: {
        label: 'Real-Time Result Rate',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    secondary_goal_result: {
        label: 'Secondary Goal Results',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    cost_per_secondary_goal_result: {
        label: 'Cost Per Secondary Goal Result',
        header: 'Basic Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    secondary_goal_result_rate: {
        label: 'Secondary Goal Result Rate',
        header: 'Basic Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    averageOrderValue: {
        label: 'Average Order Value',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'The average order value',
        formatting: 'currency',
    },
    engagements: {
        label: 'Engagements',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    engagement_rate: {
        label: 'Engagement Rate',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    follows: {
        label: 'Follows',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    likes: {
        label: 'Likes',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    comments: {
        label: 'Comments',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    shares: {
        label: 'Shares',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    profile_visits: {
        label: 'Profile Visits',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    profile_visits_rate: {
        label: 'Profile Visit Rate',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    clicks_on_music_disc: {
        label: 'Clicks on Music Disc',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    duet_clicks: {
        label: 'Duet Clicks',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    stitch_clicks: {
        label: 'Stitch Clicks',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    sound_usage_clicks: {
        label: 'Sound Usage Clicks',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    anchor_clicks: {
        label: 'Anchor Clicks',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    anchor_click_rate: {
        label: 'Anchor Click Rate',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    clicks_on_hashtag_challenge: {
        label: 'Clicks on Hashtag Challenge',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    tt_playlist_visit: {
        label: 'TikTok Playlist Visits',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    tt_playlist_visit_rate: {
        label: 'TikTok Playlist Visit Rate',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    // NOTE: These metrics exist but can only be queried from tiktok in very specific circumstances
    // single_image_impressions: {
    //   label: 'Single Image Impressions',
    //   header: 'Engagement Metrics',
    //   higherIs: 'positive',
    //   accumulation: 'sum',
    //   definition: '',
    //   formatting: 'numeric',
    // },
    // single_image_impression_rate: {
    //   label: 'Single Image Impression Rate',
    //   header: 'Engagement Metrics',
    //   higherIs: 'positive',
    //   accumulation: 'weightedAverage',
    //   definition: '',
    //   formatting: 'percentage',
    // },
    // single_image_ctr: {
    //   label: 'Single Image CTR',
    //   header: 'Engagement Metrics',
    //   higherIs: 'positive',
    //   accumulation: 'weightedAverage',
    //   definition: '',
    //   formatting: 'percentage',
    // },
    engagementPerImpression: {
        label: 'Engagement Per Impression',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Number of engagements per impression, expressed as a percentage',
        formatting: 'percentage',
    },
    costPerEngagement: {
        label: 'Cost Per Engagement',
        header: 'Engagement Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per user engagement',
        formatting: 'currency',
    },
    clicksToConversionRatio: {
        label: 'Clicks to Conversion Ratio',
        header: 'Engagement Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of clicks that resulted in a conversion',
        formatting: 'percentage',
    },
    ix_page_duration_avg: {
        label: 'Instant Experience Average View Time',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        synonyms: 'ix',
        formatting: 'numeric',
    },
    ix_page_viewrate_avg: {
        label: 'Instant Experience Average View Percentage',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        synonyms: 'ix',
        formatting: 'percentage',
    },
    ix_video_views: {
        label: 'Instant Experience Video Component Views',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        synonyms: 'ix',
        formatting: 'numeric',
    },
    ix_video_views_p25: {
        label: 'Instant Experience Video Component Views at 25%',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        synonyms: 'ix',
        formatting: 'numeric',
    },
    ix_video_views_p50: {
        label: 'Instant Experience Video Component Views at 50% ',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        synonyms: 'ix',
        formatting: 'numeric',
    },
    ix_video_views_p75: {
        label: 'Instant Experience Video Component Views at 75% ',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        synonyms: 'ix',
        formatting: 'numeric',
    },
    ix_video_views_p100: {
        label: 'Instant Experience Video Component Views at 100%',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        synonyms: 'ix',
        formatting: 'numeric',
    },
    ix_average_video_play: {
        label: 'Average View Time per Instant Experience Video Component',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        synonyms: 'ix',
        formatting: 'numeric',
    },
    vta_complete_payment: {
        label: 'VTA Completed Payments',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    cost_per_vta_payments_completed: {
        label: 'Cost Per VTA Completed Payment',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    vta_complete_payment_value: {
        label: 'VTA Completed Payment Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'currency',
    },
    vta_complete_payment_roas: {
        label: 'ROAS (VTA)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Return on ad spend (ROAS) from complete payment events attributed to someone only viewing your ad.',
        formatting: 'numeric',
    },
    total_landing_page_view: {
        label: 'Landing Page Views',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    cost_per_landing_page_view: {
        label: 'Cost Per Landing Page View',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'currency',
    },
    landing_page_view_rate: {
        label: 'Landing Page View Rate',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: '',
        formatting: 'percentage',
    },
    video_play_actions: {
        label: 'Video Plays',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: '',
        formatting: 'numeric',
    },
    video_watched_2s: {
        label: 'Video Plays (2s)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played for at least 2 seconds. For each video impression, plays are counted separately and replays are excluded.',
        formatting: 'numeric',
    },
    video_watched_6s: {
        label: 'Video Plays (6s)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played for at least 6 seconds. For each video impression, plays are counted separately and replays are excluded.',
        formatting: 'numeric',
    },
    engaged_view: {
        label: 'Engaged Views',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played for at least 6 seconds, played in full if it is less than 6 seconds, or received at least 1 engagement within the first 6 seconds.',
        formatting: 'numeric',
    },
    engaged_view_15s: {
        label: 'Engaged Views (15s)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played for at least 15 seconds, played in full if it is less than 15 seconds, or received at least 1 engagement within the first 15 seconds.',
        formatting: 'numeric',
    },
    video_views_p25: {
        label: 'Video Views (25%)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played at least 25% of its length. For each impression, views are counted separately and replays are excluded.',
        formatting: 'numeric',
    },
    video_views_p50: {
        label: 'Video Views (50%)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played at least 50% of its length. For each impression, views are counted separately and replays are excluded.',
        formatting: 'numeric',
    },
    video_views_p75: {
        label: 'Video Views (75%)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played at least 75% of its length. For each impression, views are counted separately and replays are excluded.',
        formatting: 'numeric',
    },
    video_views_p100: {
        label: 'Video Views (100%)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times your video was played 100% of its length. For each impression, views are counted separately and replays are excluded.',
        formatting: 'numeric',
    },
    average_video_play: {
        label: 'Average Video Play Time (Per View)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average time your video was played per single video view, including any time spent replaying the video.',
        formatting: 'numeric',
    },
    average_video_play_per_user: {
        label: 'Average Video Play Time (Per User)',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average time your video was played per user, including any time spent replaying the video.',
        formatting: 'numeric',
    },
    videoCompletionRate: {
        label: 'Video Completion Rate',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of video viewers who watched to 100% completion',
        formatting: 'percentage',
    },
    thumbstopRatio: {
        label: 'Thumbstop Ratio',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of impressions that watched at least 2 seconds of video',
        formatting: 'percentage',
    },
    holdRate: {
        label: 'Hold Rate',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of impressions that watched at least 6 seconds of video',
        formatting: 'percentage',
    },
    holdplayRate: {
        label: 'Holdplay Rate',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of impressions that watched at least 6 seconds of video',
        formatting: 'percentage',
    },
    thruplayRate: {
        label: 'Thruplay Rate',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of impressions that resulted in a 15-second engaged view',
        formatting: 'percentage',
    },
    videoViewRate: {
        label: 'Video View Rate',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of impressions that viewed at least 25% of the video',
        formatting: 'percentage',
    },
    p25ToP50DropoffRate: {
        label: '25-50% Dropoff Rate',
        header: 'Video Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Percentage of viewers who dropped off between 25% and 50% of the video',
        formatting: 'percentage',
    },
    p50ToP75DropoffRate: {
        label: '50-75% Dropoff Rate',
        header: 'Video Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Percentage of viewers who dropped off between 50% and 75% of the video',
        formatting: 'percentage',
    },
    p75ToP100DropoffRate: {
        label: '75-100% Dropoff Rate',
        header: 'Video Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Percentage of viewers who dropped off between 75% and 100% of the video',
        formatting: 'percentage',
    },
    firstFrameRetention: {
        label: 'First Frame Retention',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of impressions that resulted in video plays',
        formatting: 'percentage',
    },
    costPerEngagedView: {
        label: 'Cost Per Engaged View',
        header: 'Video Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per engaged view',
        formatting: 'currency',
    },
    costPer15SecondEngagedView: {
        label: 'Cost Per 15s Engaged View',
        header: 'Video Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per 15-second engaged view',
        formatting: 'currency',
    },
    costPerThruplay: {
        label: 'Cost Per Thruplay',
        header: 'Video Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per 15-second engaged view',
        formatting: 'currency',
    },
    costPerHoldplay: {
        label: 'Cost Per Holdplay',
        header: 'Video Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per 6-second video view',
        formatting: 'currency',
    },
    thruplayClickThroughRate: {
        label: 'Thruplay CTR',
        header: 'Video Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Click-through rate for users who watched significant portions of video',
        formatting: 'percentage',
    },
    registration: {
        label: 'Registrations',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of registrations',
        formatting: 'numeric',
    },
    cost_per_registration: {
        label: 'Cost Per Registration',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per registration event.',
        formatting: 'currency',
    },
    registration_rate: {
        label: 'Registration Rate',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who registered after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    total_registration: {
        label: 'Total Registrations',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of registrations across all attribution windows.',
        formatting: 'numeric',
    },
    cost_per_total_registration: {
        label: 'Cost Per Total Registration',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total registrations across all attribution windows.',
        formatting: 'currency',
    },
    purchase: {
        label: 'Purchases',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of purchases attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_purchase: {
        label: 'Cost Per Purchase',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per purchase.',
        formatting: 'currency',
    },
    purchase_rate: {
        label: 'Purchase Rate',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who made a purchase after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    total_purchase: {
        label: 'Total Purchases',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of purchases across all attribution windows.',
        formatting: 'numeric',
    },
    cost_per_total_purchase: {
        label: 'Cost Per Total Purchase',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total purchases across all attribution windows.',
        formatting: 'currency',
    },
    value_per_total_purchase: {
        label: 'Value Per Total Purchase',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per purchase across all attribution windows.',
        formatting: 'currency',
    },
    total_purchase_value: {
        label: 'Total Purchase Value',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all purchases attributed to your ads.',
        formatting: 'currency',
    },
    total_active_pay_roas: {
        label: 'Total Active Pay ROAS',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Return on ad spend for total purchases actively attributed to your ads.',
        formatting: 'numeric',
    },
    app_event_add_to_cart: {
        label: 'Add to Cart (App)',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of add to cart events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_app_event_add_to_cart: {
        label: 'Cost Per Add to Cart (App)',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per add to cart event.',
        formatting: 'currency',
    },
    app_event_add_to_cart_rate: {
        label: 'Add to Cart Rate (App)',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who added items to cart after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    total_app_event_add_to_cart: {
        label: 'Total Add to Cart (App)',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of add to cart events across all attribution windows.',
        formatting: 'numeric',
    },
    cost_per_total_app_event_add_to_cart: {
        label: 'Cost Per Total Add to Cart (App)',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total add to cart events across all attribution windows.',
        formatting: 'currency',
    },
    value_per_total_app_event_add_to_cart: {
        label: 'Value Per Total Add to Cart (App)',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per add to cart event across all attribution windows.',
        formatting: 'currency',
    },
    total_app_event_add_to_cart_value: {
        label: 'Total Add to Cart Value (App)',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all add to cart events attributed to your ads.',
        formatting: 'currency',
    },
    checkout: {
        label: 'Checkout',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of checkout events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_checkout: {
        label: 'Cost Per Checkout',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per checkout event.',
        formatting: 'currency',
    },
    checkout_rate: {
        label: 'Checkout Rate',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who initiated checkout after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    total_checkout: {
        label: 'Total Checkout',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of checkout events across all attribution windows.',
        formatting: 'numeric',
    },
    cost_per_total_checkout: {
        label: 'Cost Per Total Checkout',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total checkout events across all attribution windows.',
        formatting: 'currency',
    },
    value_per_checkout: {
        label: 'Value Per Checkout',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per checkout event.',
        formatting: 'currency',
    },
    total_checkout_value: {
        label: 'Total Checkout Value',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all checkout events attributed to your ads.',
        formatting: 'currency',
    },
    sales_lead: {
        label: 'Sales Leads',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of lead generation events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_sales_lead: {
        label: 'Cost Per Sales Lead',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per lead generation event.',
        formatting: 'currency',
    },
    sales_lead_rate: {
        label: 'Sales Lead Rate',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who became leads after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    total_sales_lead: {
        label: 'Total Sales Leads',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of lead generation events across all attribution windows.',
        formatting: 'numeric',
    },
    cost_per_total_sales_lead: {
        label: 'Cost Per Total Sales Lead',
        header: 'Conversion Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total lead generation events across all attribution windows.',
        formatting: 'currency',
    },
    value_per_total_sales_lead: {
        label: 'Value Per Total Sales Lead',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per lead across all attribution windows.',
        formatting: 'currency',
    },
    total_sales_lead_value: {
        label: 'Total Sales Lead Value',
        header: 'Conversion Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all leads attributed to your ads.',
        formatting: 'currency',
    },
    // App Metrics
    real_time_app_install: {
        label: 'Real-Time App Installs',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of app installs that occurred in real-time (without attribution delay).',
        formatting: 'numeric',
    },
    real_time_app_install_cost: {
        label: 'Real-Time App Install Cost',
        header: 'App Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per app install that occurred in real-time.',
        formatting: 'currency',
    },
    app_install: {
        label: 'App Installs',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of app installs attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_app_install: {
        label: 'Cost Per App Install',
        header: 'App Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per app install.',
        formatting: 'currency',
    },
    launch_app: {
        label: 'App Launches',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of times users launched the app after interacting with your ad.',
        formatting: 'numeric',
    },
    total_launch_app: {
        label: 'Total App Launches',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of app launches across all attribution windows.',
        formatting: 'numeric',
    },
    next_day_open: {
        label: 'Next Day Opens',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of users who opened the app the day after installation.',
        formatting: 'numeric',
    },
    total_next_day_open: {
        label: 'Total Next Day Opens',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of next-day opens across all attribution windows.',
        formatting: 'numeric',
    },
    login: {
        label: 'App Logins',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of user logins attributed to your ads.',
        formatting: 'numeric',
    },
    total_login: {
        label: 'Total App Logins',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of logins across all attribution windows.',
        formatting: 'numeric',
    },
    search: {
        label: 'In-App Searches',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of in-app searches attributed to your ads.',
        formatting: 'numeric',
    },
    total_search: {
        label: 'Total In-App Searches',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of searches across all attribution windows.',
        formatting: 'numeric',
    },
    day7_retention: {
        label: 'Day 7 Retention',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who returned to the app 7 days after installation.',
        formatting: 'percentage',
    },
    total_day7_retention: {
        label: 'Total Day 7 Retention',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of 7-day retention events across all attribution windows.',
        formatting: 'numeric',
    },
    total_day7_retention_value: {
        label: 'Total Day 7 Retention Value',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with 7-day retention events.',
        formatting: 'currency',
    },
    start_trial: {
        label: 'Trial Starts',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of trial start events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_start_trial: {
        label: 'Cost Per Trial Start',
        header: 'App Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per trial start event.',
        formatting: 'currency',
    },
    start_trial_rate: {
        label: 'Trial Start Rate',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who started a trial after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    total_start_trial: {
        label: 'Total Trial Starts',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of trial start events across all attribution windows.',
        formatting: 'numeric',
    },
    cost_per_total_start_trial: {
        label: 'Cost Per Total Trial Start',
        header: 'App Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total trial start events across all attribution windows.',
        formatting: 'currency',
    },
    subscribe: {
        label: 'Subscriptions',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of subscription events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_subscribe: {
        label: 'Cost Per Subscription',
        header: 'App Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per subscription event.',
        formatting: 'currency',
    },
    subscribe_rate: {
        label: 'Subscription Rate',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who subscribed after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    total_subscribe: {
        label: 'Total Subscriptions',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of subscription events across all attribution windows.',
        formatting: 'numeric',
    },
    cost_per_total_subscribe: {
        label: 'Cost Per Total Subscription',
        header: 'App Metrics',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total subscription events across all attribution windows.',
        formatting: 'currency',
    },
    value_per_total_subscribe: {
        label: 'Value Per Total Subscription',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per subscription across all attribution windows.',
        formatting: 'currency',
    },
    total_subscribe_value: {
        label: 'Total Subscription Value',
        header: 'App Metrics',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all subscriptions attributed to your ads.',
        formatting: 'currency',
    },
    // Gaming Metrics
    achieve_level: {
        label: 'Level Achievements',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of level achievements in a game attributed to your ads.',
        formatting: 'numeric',
    },
    total_achieve_level: {
        label: 'Total Level Achievements',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of level achievements across all attribution windows.',
        formatting: 'numeric',
    },
    total_achieve_level_value: {
        label: 'Total Level Achievement Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with level achievements.',
        formatting: 'currency',
    },
    complete_tutorial: {
        label: 'Tutorial Completions',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of tutorial completions attributed to your ads.',
        formatting: 'numeric',
    },
    total_complete_tutorial: {
        label: 'Total Tutorial Completions',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of tutorial completions across all attribution windows.',
        formatting: 'numeric',
    },
    total_complete_tutorial_value: {
        label: 'Total Tutorial Completion Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with tutorial completions.',
        formatting: 'currency',
    },
    create_gamerole: {
        label: 'Game Role Creations',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of game character/role creations attributed to your ads.',
        formatting: 'numeric',
    },
    total_create_gamerole: {
        label: 'Total Game Role Creations',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of game role creations across all attribution windows.',
        formatting: 'numeric',
    },
    total_create_gamerole_value: {
        label: 'Total Game Role Creation Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with game role creations.',
        formatting: 'currency',
    },
    unlock_achievement: {
        label: 'Achievement Unlocks',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of achievements unlocked attributed to your ads.',
        formatting: 'numeric',
    },
    total_unlock_achievement: {
        label: 'Total Achievement Unlocks',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of achievement unlocks across all attribution windows.',
        formatting: 'numeric',
    },
    total_unlock_achievement_value: {
        label: 'Total Achievement Unlock Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with achievement unlocks.',
        formatting: 'currency',
    },
    // Social Metrics
    create_group: {
        label: 'Group Creations',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of group creations attributed to your ads.',
        formatting: 'numeric',
    },
    total_create_group: {
        label: 'Total Group Creations',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of group creations across all attribution windows.',
        formatting: 'numeric',
    },
    total_create_group_value: {
        label: 'Total Group Creation Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with group creations.',
        formatting: 'currency',
    },
    join_group: {
        label: 'Group Joins',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of group joins attributed to your ads.',
        formatting: 'numeric',
    },
    total_join_group: {
        label: 'Total Group Joins',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of group joins across all attribution windows.',
        formatting: 'numeric',
    },
    total_join_group_value: {
        label: 'Total Group Join Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with group joins.',
        formatting: 'currency',
    },
    // In-App Ad Metrics
    ads_impression_events: {
        label: 'Ad Impression Events',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of in-app ad impressions attributed to your ads.',
        formatting: 'numeric',
    },
    total_ad_impression_events_value: {
        label: 'Total Ad Impression Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value generated from in-app ad impressions.',
        formatting: 'currency',
    },
    in_app_ad_click: {
        label: 'In-App Ad Clicks',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of clicks on in-app ads attributed to your campaigns.',
        formatting: 'numeric',
    },
    total_in_app_ad_click: {
        label: 'Total In-App Ad Clicks',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of in-app ad clicks across all attribution windows.',
        formatting: 'numeric',
    },
    total_in_app_ad_click_value: {
        label: 'Total In-App Ad Click Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value generated from in-app ad clicks.',
        formatting: 'currency',
    },
    in_app_ad_impr: {
        label: 'In-App Ad Impressions',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of in-app ad impressions attributed to your campaigns.',
        formatting: 'numeric',
    },
    total_in_app_ad_impr: {
        label: 'Total In-App Ad Impressions',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of in-app ad impressions across all attribution windows.',
        formatting: 'numeric',
    },
    total_in_app_ad_impr_value: {
        label: 'Total In-App Ad Impression Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value generated from in-app ad impressions.',
        formatting: 'currency',
    },
    unique_ad_impression_events: {
        label: 'Unique Ad Impression Events',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of unique users who viewed in-app ads attributed to your campaigns.',
        formatting: 'numeric',
    },
    // Finance Metrics
    loan_apply: {
        label: 'Loan Applications',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of loan applications attributed to your ads.',
        formatting: 'numeric',
    },
    total_loan_apply: {
        label: 'Total Loan Applications',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of loan applications across all attribution windows.',
        formatting: 'numeric',
    },
    loan_credit: {
        label: 'Loan Credit',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of loan credit approvals attributed to your ads.',
        formatting: 'numeric',
    },
    total_loan_credit: {
        label: 'Total Loan Credit',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of loan credit approvals across all attribution windows.',
        formatting: 'numeric',
    },
    loan_disbursement: {
        label: 'Loan Disbursements',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of loan disbursements attributed to your ads.',
        formatting: 'numeric',
    },
    total_loan_disbursement: {
        label: 'Total Loan Disbursements',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of loan disbursements across all attribution windows.',
        formatting: 'numeric',
    },
    spend_credits: {
        label: 'Credit Spending',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of credit spending events attributed to your ads.',
        formatting: 'numeric',
    },
    total_spend_credits: {
        label: 'Total Credit Spending',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of credit spending events across all attribution windows.',
        formatting: 'numeric',
    },
    total_spend_credits_value: {
        label: 'Total Credit Spending Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with credit spending events.',
        formatting: 'currency',
    },
    // Custom Event Metrics
    custom_app_events: {
        label: 'Custom App Events',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of custom app events attributed to your ads.',
        formatting: 'numeric',
    },
    custom_app_events_value: {
        label: 'Custom App Events Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Monetary value associated with custom app events.',
        formatting: 'currency',
    },
    unique_custom_app_events: {
        label: 'Unique Custom App Events',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of unique users who triggered custom app events attributed to your ads.',
        formatting: 'numeric',
    },
    view_content: {
        label: 'Content Views',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of content views attributed to your ads.',
        formatting: 'numeric',
    },
    total_view_content: {
        label: 'Total Content Views',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of content views across all attribution windows.',
        formatting: 'numeric',
    },
    total_view_content_value: {
        label: 'Total Content View Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with content views.',
        formatting: 'currency',
    },
    ratings: {
        label: 'Ratings',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of ratings/reviews attributed to your ads.',
        formatting: 'numeric',
    },
    total_ratings: {
        label: 'Total Ratings',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of ratings/reviews across all attribution windows.',
        formatting: 'numeric',
    },
    total_ratings_value: {
        label: 'Total Ratings Value',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with ratings/reviews.',
        formatting: 'currency',
    },
    cta_conversion: {
        label: 'Conversion (CTA)',
        header: 'Conversion (CTA)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Conversion rate (CTA)',
        formatting: 'numeric',
    },
    cta_purchase: {
        label: 'Purchases (CTA)',
        header: 'Purchases (CTA)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of purchases (CTA)',
        formatting: 'numeric',
    },
    web_event_add_to_cart: {
        label: 'Add to Cart (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of add to cart events on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_web_event_add_to_cart: {
        label: 'Cost Per Add to Cart (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per add to cart event on your website.',
        formatting: 'currency',
    },
    web_event_add_to_cart_rate: {
        label: 'Add to Cart Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who added items to cart on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_web_event_add_to_cart: {
        label: 'Value Per Add to Cart (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per add to cart event on your website.',
        formatting: 'currency',
    },
    total_web_event_add_to_cart_value: {
        label: 'Total Add to Cart Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all add to cart events on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Web Order Metrics
    on_web_order: {
        label: 'Orders (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of orders placed on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_on_web_order: {
        label: 'Cost Per Order (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per order placed on your website.',
        formatting: 'currency',
    },
    on_web_order_rate: {
        label: 'Order Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who placed an order on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_on_web_order: {
        label: 'Value Per Order (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per order placed on your website.',
        formatting: 'currency',
    },
    total_on_web_order_value: {
        label: 'Total Order Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all orders placed on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Web Checkout Metrics
    initiate_checkout: {
        label: 'Checkout Initiated (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of checkout initiations on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_initiate_checkout: {
        label: 'Cost Per Checkout Initiated (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per checkout initiation on your website.',
        formatting: 'currency',
    },
    initiate_checkout_rate: {
        label: 'Checkout Initiation Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who initiated checkout on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_initiate_checkout: {
        label: 'Value Per Checkout Initiated (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value per checkout initiation on your website.',
        formatting: 'currency',
    },
    total_initiate_checkout_value: {
        label: 'Total Checkout Initiated Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value of all checkout initiations on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Payment Metrics
    add_billing: {
        label: 'Add Billing Information (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of billing information additions on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_add_billing: {
        label: 'Cost Per Add Billing (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per billing information addition on your website.',
        formatting: 'currency',
    },
    add_billing_rate: {
        label: 'Add Billing Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who added billing information on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_add_billing: {
        label: 'Value Per Add Billing (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with billing information additions on your website.',
        formatting: 'currency',
    },
    total_add_billing_value: {
        label: 'Total Add Billing Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with billing information additions on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Search Metrics
    page_event_search: {
        label: 'Search (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of search events on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_page_event_search: {
        label: 'Cost Per Search (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per search event on your website.',
        formatting: 'currency',
    },
    page_event_search_rate: {
        label: 'Search Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who performed a search on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_page_event_search: {
        label: 'Value Per Search (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with search events on your website.',
        formatting: 'currency',
    },
    total_page_event_search_value: {
        label: 'Total Search Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with search events on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Form Metrics
    form: {
        label: 'Form Submission (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of form submissions on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_form: {
        label: 'Cost Per Form Submission (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per form submission on your website.',
        formatting: 'currency',
    },
    form_rate: {
        label: 'Form Submission Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who submitted a form on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_form: {
        label: 'Value Per Form Submission (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with form submissions on your website.',
        formatting: 'currency',
    },
    total_form_value: {
        label: 'Total Form Submission Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with form submissions on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Download Metrics
    download_start: {
        label: 'Download Started (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of download initiation events on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_download_start: {
        label: 'Cost Per Download Started (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per download initiation on your website.',
        formatting: 'currency',
    },
    download_start_rate: {
        label: 'Download Start Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who initiated a download on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_download_start: {
        label: 'Value Per Download Started (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with download initiations on your website.',
        formatting: 'currency',
    },
    total_download_start_value: {
        label: 'Total Download Started Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with download initiations on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Wishlist Metrics
    on_web_add_to_wishlist: {
        label: 'Add to Wishlist (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of wishlist additions on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_on_web_add_to_wishlist: {
        label: 'Cost Per Add to Wishlist (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per wishlist addition on your website.',
        formatting: 'currency',
    },
    on_web_add_to_wishlist_per_click: {
        label: 'Add to Wishlist Per Click (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average number of wishlist additions per click on your website.',
        formatting: 'numeric',
    },
    value_per_on_web_add_to_wishlist: {
        label: 'Value Per Add to Wishlist (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with wishlist additions on your website.',
        formatting: 'currency',
    },
    total_on_web_add_to_wishlist_value: {
        label: 'Total Add to Wishlist Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with wishlist additions on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Web Subscribe Metrics
    on_web_subscribe: {
        label: 'Subscribe (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of subscription events on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_on_web_subscribe: {
        label: 'Cost Per Subscribe (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per subscription event on your website.',
        formatting: 'currency',
    },
    on_web_subscribe_per_click: {
        label: 'Subscribe Per Click (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average number of subscription events per click on your website.',
        formatting: 'numeric',
    },
    value_per_on_web_subscribe: {
        label: 'Value Per Subscribe (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with subscription events on your website.',
        formatting: 'currency',
    },
    total_on_web_subscribe_value: {
        label: 'Total Subscribe Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with subscription events on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Custom Page Events
    custom_page_events: {
        label: 'Custom Page Events (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of custom page events on your website attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_custom_page_event: {
        label: 'Cost Per Custom Page Event (Website)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per custom page event on your website.',
        formatting: 'currency',
    },
    custom_page_event_rate: {
        label: 'Custom Page Event Rate (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who triggered a custom page event on your website after seeing or clicking on your ad.',
        formatting: 'percentage',
    },
    value_per_custom_page_event: {
        label: 'Value Per Custom Page Event (Website)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with custom page events on your website.',
        formatting: 'currency',
    },
    custom_page_events_value: {
        label: 'Custom Page Events Value (Website)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with custom page events on your website attributed to your ads.',
        formatting: 'currency',
    },
    // Onsite Metrics
    onsite_add_to_wishlist: {
        label: 'Add to Wishlist (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of wishlist additions in TikTok's onsite shopping experience attributed to your ads.",
        formatting: 'numeric',
    },
    cost_per_onsite_add_to_wishlist: {
        label: 'Cost Per Add to Wishlist (Onsite)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per wishlist addition in TikTok's onsite shopping experience.",
        formatting: 'currency',
    },
    onsite_add_to_wishlist_rate: {
        label: 'Add to Wishlist Rate (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who added items to wishlist in TikTok's onsite shopping experience after seeing your ad.",
        formatting: 'percentage',
    },
    value_per_onsite_add_to_wishlist: {
        label: 'Value Per Add to Wishlist (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Average monetary value associated with wishlist additions in TikTok's onsite shopping experience.",
        formatting: 'currency',
    },
    total_onsite_add_to_wishlist_value: {
        label: 'Total Add to Wishlist Value (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value associated with wishlist additions in TikTok's onsite shopping experience attributed to your ads.",
        formatting: 'currency',
    },
    onsite_add_billing: {
        label: 'Add Billing Information (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of billing information additions in TikTok's onsite shopping experience attributed to your ads.",
        formatting: 'numeric',
    },
    cost_per_onsite_add_billing: {
        label: 'Cost Per Add Billing (Onsite)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per billing information addition in TikTok's onsite shopping experience.",
        formatting: 'currency',
    },
    onsite_add_billing_rate: {
        label: 'Add Billing Rate (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who added billing information in TikTok's onsite shopping experience after seeing your ad.",
        formatting: 'percentage',
    },
    value_per_onsite_add_billing: {
        label: 'Value Per Add Billing (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Average monetary value associated with billing information additions in TikTok's onsite shopping experience.",
        formatting: 'currency',
    },
    total_onsite_add_billing_value: {
        label: 'Total Add Billing Value (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value associated with billing information additions in TikTok's onsite shopping experience attributed to your ads.",
        formatting: 'currency',
    },
    onsite_form: {
        label: 'Form Submission (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of form submissions in TikTok's onsite experience attributed to your ads.",
        formatting: 'numeric',
    },
    cost_per_onsite_form: {
        label: 'Cost Per Form Submission (Onsite)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per form submission in TikTok's onsite experience.",
        formatting: 'currency',
    },
    onsite_form_rate: {
        label: 'Form Submission Rate (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who submitted a form in TikTok's onsite experience after seeing your ad.",
        formatting: 'percentage',
    },
    value_per_onsite_form: {
        label: 'Value Per Form Submission (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Average monetary value associated with form submissions in TikTok's onsite experience.",
        formatting: 'currency',
    },
    total_onsite_form_value: {
        label: 'Total Form Submission Value (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value associated with form submissions in TikTok's onsite experience attributed to your ads.",
        formatting: 'currency',
    },
    onsite_download_start: {
        label: 'Download Started (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of download initiation events in TikTok's onsite experience attributed to your ads.",
        formatting: 'numeric',
    },
    cost_per_onsite_download_start: {
        label: 'Cost Per Download Started (Onsite)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per download initiation in TikTok's onsite experience.",
        formatting: 'currency',
    },
    onsite_download_start_rate: {
        label: 'Download Start Rate (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who initiated a download in TikTok's onsite experience after seeing your ad.",
        formatting: 'percentage',
    },
    onsite_destination_visits: {
        label: 'Destination Visits (Onsite)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of destination visits in TikTok's onsite experience attributed to your ads.",
        formatting: 'numeric',
    },
    cost_per_onsite_destination_visit: {
        label: 'Cost Per Destination Visit (Onsite)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per destination visit in TikTok's onsite experience.",
        formatting: 'currency',
    },
    onsite_destination_visit_rate: {
        label: 'Destination Visit Rate (Onsite)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who visited a destination in TikTok's onsite experience after seeing your ad.",
        formatting: 'percentage',
    },
    // Instant Experience (IX) Metrics
    ix_page_view_count: {
        label: 'Page Views (IX)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of page views in Instant Experience attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_ix_page_view_count: {
        label: 'Cost Per Page View (IX)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per page view in Instant Experience.',
        formatting: 'currency',
    },
    ix_page_view_count_rate: {
        label: 'Page View Rate (IX)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who viewed a page in Instant Experience after seeing your ad.',
        formatting: 'percentage',
    },
    ix_button_click_count: {
        label: 'Button Clicks (IX)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of button clicks in Instant Experience attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_ix_button_click_count: {
        label: 'Cost Per Button Click (IX)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per button click in Instant Experience.',
        formatting: 'currency',
    },
    ix_button_click_count_rate: {
        label: 'Button Click Rate (IX)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who clicked a button in Instant Experience after seeing your ad.',
        formatting: 'percentage',
    },
    ix_product_click_count: {
        label: 'Product Clicks (IX)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of product clicks in Instant Experience attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_ix_product_click_count: {
        label: 'Cost Per Product Click (IX)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per product click in Instant Experience.',
        formatting: 'currency',
    },
    ix_product_click_count_rate: {
        label: 'Product Click Rate (IX)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who clicked a product in Instant Experience after seeing your ad.',
        formatting: 'percentage',
    },
    // Offline Event Metrics
    offline_shopping_events: {
        label: 'Shopping Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline shopping events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_shopping_event: {
        label: 'Cost Per Shopping Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline shopping event.',
        formatting: 'currency',
    },
    offline_shopping_event_rate: {
        label: 'Shopping Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline shopping event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_shopping_event: {
        label: 'Value Per Shopping Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline shopping events.',
        formatting: 'currency',
    },
    offline_shopping_events_value: {
        label: 'Shopping Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline shopping events attributed to your ads.',
        formatting: 'currency',
    },
    offline_shopping_events_roas: {
        label: 'Shopping Events ROAS (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Return on ad spend for offline shopping events attributed to your ads.',
        formatting: 'numeric',
    },
    // Additional offline event categories (similar pattern for each)
    offline_contact_events: {
        label: 'Contact Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline contact events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_contact_event: {
        label: 'Cost Per Contact Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline contact event.',
        formatting: 'currency',
    },
    offline_contact_event_rate: {
        label: 'Contact Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline contact event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_contact_event: {
        label: 'Value Per Contact Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline contact events.',
        formatting: 'currency',
    },
    offline_contact_events_value: {
        label: 'Contact Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline contact events attributed to your ads.',
        formatting: 'currency',
    },
    // SKAN Metrics (SKAdNetwork - Apple's privacy-focused attribution system)
    skan_result: {
        label: 'Results (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of results attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_result: {
        label: 'Cost Per Result (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per result attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_result_rate: {
        label: 'Result Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who generated a result, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_conversion: {
        label: 'Conversions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of conversions attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_conversion: {
        label: 'Cost Per Conversion (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per conversion attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_conversion_rate: {
        label: 'Conversion Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who converted, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_conversion_rate_v2: {
        label: 'Conversion Rate V2 (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Updated version of conversion rate measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_app_install: {
        label: 'App Installs (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of app installs attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_app_install: {
        label: 'Cost Per App Install (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per app install attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_app_install_withheld: {
        label: 'App Installs Withheld (SKAN)',
        higherIs: 'neutral',
        accumulation: 'sum',
        definition: "Number of app installs that were withheld due to Apple's privacy thresholds in SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_registration: {
        label: 'Registrations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of registrations attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_registration: {
        label: 'Cost Per Registration (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per registration attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_registration_rate: {
        label: 'Registration Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who registered, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_registration: {
        label: 'Total Registrations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of registrations across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_registration: {
        label: 'Cost Per Total Registration (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total registrations across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_purchase: {
        label: 'Purchases (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of purchases attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_purchase: {
        label: 'Cost Per Purchase (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per purchase attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_purchase_rate: {
        label: 'Purchase Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who made a purchase, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_purchase: {
        label: 'Total Purchases (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of purchases across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_purchase: {
        label: 'Cost Per Total Purchase (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total purchases across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_purchase_value: {
        label: 'Total Purchase Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value of all purchases attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_total_repetitive_active_pay_roas: {
        label: 'Total Repetitive Active Pay ROAS (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Return on ad spend for repetitive purchases attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_add_to_cart: {
        label: 'Add to Cart (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of add to cart events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_add_to_cart: {
        label: 'Cost Per Add to Cart (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per add to cart event attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_add_to_cart_rate: {
        label: 'Add to Cart Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who added items to cart, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_add_to_cart: {
        label: 'Total Add to Cart (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of add to cart events across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_add_to_cart: {
        label: 'Cost Per Total Add to Cart (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total add to cart events across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_add_to_cart_value: {
        label: 'Total Add to Cart Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value of all add to cart events attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_checkout: {
        label: 'Checkout (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of checkout events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_checkout: {
        label: 'Cost Per Checkout (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per checkout event attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_checkout_rate: {
        label: 'Checkout Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who initiated checkout, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_checkout: {
        label: 'Total Checkout (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of checkout events across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_checkout: {
        label: 'Cost Per Total Checkout (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total checkout events across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_checkout_value: {
        label: 'Total Checkout Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value of all checkout events attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_view_content: {
        label: 'Content Views (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of content views attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_view_content: {
        label: 'Cost Per Content View (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per content view attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_view_content_rate: {
        label: 'Content View Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who viewed content, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_view_content: {
        label: 'Total Content Views (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of content views across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_view_content: {
        label: 'Cost Per Total Content View (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total content views across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_view_content_value: {
        label: 'Total Content View Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value of all content views attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_add_payment_info: {
        label: 'Add Payment Info (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of payment information additions attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_add_payment_info: {
        label: 'Cost Per Add Payment Info (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per payment information addition attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_add_payment_info_rate: {
        label: 'Add Payment Info Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who added payment information, as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_add_payment_info: {
        label: 'Total Add Payment Info (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of payment information additions across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_total_add_payment_info: {
        label: 'Cost Per Total Add Payment Info (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total payment information additions across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    // Added Metrics for Offline Events
    offline_subscribe_events: {
        label: 'Subscribe Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline subscription events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_subscribe_event: {
        label: 'Cost Per Subscribe Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline subscription event.',
        formatting: 'currency',
    },
    offline_subscribe_event_rate: {
        label: 'Subscribe Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline subscription event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_subscribe_event: {
        label: 'Value Per Subscribe Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline subscription events.',
        formatting: 'currency',
    },
    offline_subscribe_events_value: {
        label: 'Subscribe Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline subscription events attributed to your ads.',
        formatting: 'currency',
    },
    offline_form_events: {
        label: 'Form Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline form submission events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_form_event: {
        label: 'Cost Per Form Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline form submission event.',
        formatting: 'currency',
    },
    offline_form_event_rate: {
        label: 'Form Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline form submission event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_form_event: {
        label: 'Value Per Form Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline form submission events.',
        formatting: 'currency',
    },
    offline_form_events_value: {
        label: 'Form Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline form submission events attributed to your ads.',
        formatting: 'currency',
    },
    offline_add_payment_info_events: {
        label: 'Add Payment Info Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline payment information addition events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_add_payment_info_event: {
        label: 'Cost Per Add Payment Info Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline payment information addition event.',
        formatting: 'currency',
    },
    offline_add_payment_info_event_rate: {
        label: 'Add Payment Info Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline payment information addition event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_add_payment_info_event: {
        label: 'Value Per Add Payment Info Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline payment information addition events.',
        formatting: 'currency',
    },
    offline_add_payment_info_events_value: {
        label: 'Add Payment Info Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline payment information addition events attributed to your ads.',
        formatting: 'currency',
    },
    offline_add_to_cart_events: {
        label: 'Add to Cart Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline add to cart events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_add_to_cart_event: {
        label: 'Cost Per Add to Cart Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline add to cart event.',
        formatting: 'currency',
    },
    offline_add_to_cart_event_rate: {
        label: 'Add to Cart Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline add to cart event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_add_to_cart_event: {
        label: 'Value Per Add to Cart Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline add to cart events.',
        formatting: 'currency',
    },
    offline_add_to_cart_events_value: {
        label: 'Add to Cart Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline add to cart events attributed to your ads.',
        formatting: 'currency',
    },
    offline_add_to_wishlist_events: {
        label: 'Add to Wishlist Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline add to wishlist events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_add_to_wishlist_event: {
        label: 'Cost Per Add to Wishlist Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline add to wishlist event.',
        formatting: 'currency',
    },
    offline_add_to_wishlist_event_rate: {
        label: 'Add to Wishlist Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline add to wishlist event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_add_to_wishlist_event: {
        label: 'Value Per Add to Wishlist Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline add to wishlist events.',
        formatting: 'currency',
    },
    offline_add_to_wishlist_events_value: {
        label: 'Add to Wishlist Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline add to wishlist events attributed to your ads.',
        formatting: 'currency',
    },
    offline_click_button_events: {
        label: 'Button Click Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline button click events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_click_button_event: {
        label: 'Cost Per Button Click Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline button click event.',
        formatting: 'currency',
    },
    offline_click_button_event_rate: {
        label: 'Button Click Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline button click event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_click_button_event: {
        label: 'Value Per Button Click Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline button click events.',
        formatting: 'currency',
    },
    offline_click_button_events_value: {
        label: 'Button Click Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline button click events attributed to your ads.',
        formatting: 'currency',
    },
    offline_complete_registration_events: {
        label: 'Registration Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline registration completion events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_complete_registration_event: {
        label: 'Cost Per Registration Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline registration completion event.',
        formatting: 'currency',
    },
    offline_complete_registration_event_rate: {
        label: 'Registration Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline registration event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_complete_registration_event: {
        label: 'Value Per Registration Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline registration completion events.',
        formatting: 'currency',
    },
    offline_complete_registration_events_value: {
        label: 'Registration Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline registration completion events attributed to your ads.',
        formatting: 'currency',
    },
    offline_download_events: {
        label: 'Download Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline download events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_download_event: {
        label: 'Cost Per Download Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline download event.',
        formatting: 'currency',
    },
    offline_download_event_rate: {
        label: 'Download Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline download event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_download_event: {
        label: 'Value Per Download Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline download events.',
        formatting: 'currency',
    },
    offline_download_events_value: {
        label: 'Download Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline download events attributed to your ads.',
        formatting: 'currency',
    },
    offline_initiate_checkout_events: {
        label: 'Checkout Initiation Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline checkout initiation events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_initiate_checkout_event: {
        label: 'Cost Per Checkout Initiation Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline checkout initiation event.',
        formatting: 'currency',
    },
    offline_initiate_checkout_event_rate: {
        label: 'Checkout Initiation Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who initiated an offline checkout event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_initiate_checkout_event: {
        label: 'Value Per Checkout Initiation Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline checkout initiation events.',
        formatting: 'currency',
    },
    offline_initiate_checkout_events_value: {
        label: 'Checkout Initiation Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline checkout initiation events attributed to your ads.',
        formatting: 'currency',
    },
    offline_place_order_events: {
        label: 'Order Placement Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline order placement events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_place_order_event: {
        label: 'Cost Per Order Placement Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline order placement event.',
        formatting: 'currency',
    },
    offline_place_order_event_rate: {
        label: 'Order Placement Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline order placement event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_place_order_event: {
        label: 'Value Per Order Placement Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline order placement events.',
        formatting: 'currency',
    },
    offline_place_order_events_value: {
        label: 'Order Placement Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline order placement events attributed to your ads.',
        formatting: 'currency',
    },
    offline_search_events: {
        label: 'Search Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline search events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_search_event: {
        label: 'Cost Per Search Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline search event.',
        formatting: 'currency',
    },
    offline_search_event_rate: {
        label: 'Search Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline search event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_search_event: {
        label: 'Value Per Search Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline search events.',
        formatting: 'currency',
    },
    offline_search_events_value: {
        label: 'Search Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline search events attributed to your ads.',
        formatting: 'currency',
    },
    offline_view_content_events: {
        label: 'Content View Events (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Number of offline content view events attributed to your ads.',
        formatting: 'numeric',
    },
    cost_per_offline_view_content_event: {
        label: 'Cost Per Content View Event (Offline)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per offline content view event.',
        formatting: 'currency',
    },
    offline_view_content_event_rate: {
        label: 'Content View Event Rate (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Percentage of users who completed an offline content view event after seeing your ad.',
        formatting: 'percentage',
    },
    value_per_offline_view_content_event: {
        label: 'Value Per Content View Event (Offline)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: 'Average monetary value associated with offline content view events.',
        formatting: 'currency',
    },
    offline_view_content_events_value: {
        label: 'Content View Events Value (Offline)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with offline content view events attributed to your ads.',
        formatting: 'currency',
    },
    // SKAN Click Time Metrics
    skan_click_time_conversion: {
        label: 'Click Time Conversions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of conversions based on click time attribution through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_click_time_cost_per_conversion: {
        label: 'Click Time Cost Per Conversion (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per conversion based on click time attribution through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_click_time_conversion_rate: {
        label: 'Click Time Conversion Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who converted based on click time attribution through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_click_time_conversion_rate_v2: {
        label: 'Click Time Conversion Rate V2 (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Updated version of conversion rate based on click time attribution through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    // SKAN Wishlist Metrics
    skan_add_to_wishlist: {
        label: 'Add to Wishlist (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of wishlist additions attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_add_to_wishlist: {
        label: 'Cost Per Add to Wishlist (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per wishlist addition attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_add_to_wishlist_rate: {
        label: 'Add to Wishlist Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who added items to wishlist as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_add_to_wishlist: {
        label: 'Total Add to Wishlist (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of wishlist additions across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_add_to_wishlist: {
        label: 'Cost Per Total Add to Wishlist (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total wishlist additions across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_add_to_wishlist_value: {
        label: 'Total Add to Wishlist Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Total monetary value of all wishlist additions attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    // SKAN App Launch Metrics
    skan_launch_app: {
        label: 'App Launches (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of app launch events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_launch_app: {
        label: 'Cost Per App Launch (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per app launch attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_launch_app_rate: {
        label: 'App Launch Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who launched the app as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_launch_app: {
        label: 'Total App Launches (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of app launches across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_launch_app: {
        label: 'Cost Per Total App Launch (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total app launches across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Tutorial Metrics
    skan_total_complete_tutorial: {
        label: 'Total Tutorial Completions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of tutorial completions across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_complete_tutorial: {
        label: 'Cost Per Total Tutorial Completion (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total tutorial completions across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_complete_tutorial: {
        label: 'Tutorial Completions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of tutorial completions attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_complete_tutorial: {
        label: 'Cost Per Tutorial Completion (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per tutorial completion attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_complete_tutorial_rate: {
        label: 'Tutorial Completion Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who completed tutorials as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_complete_tutorial_value: {
        label: 'Total Tutorial Completion Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with tutorial completions through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Group Metrics
    skan_create_group: {
        label: 'Group Creations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of group creation events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_create_group: {
        label: 'Cost Per Group Creation (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per group creation attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_create_group_rate: {
        label: 'Group Creation Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who created groups as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_create_group: {
        label: 'Total Group Creations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of group creations across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_create_group: {
        label: 'Cost Per Total Group Creation (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total group creations across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_create_group_value: {
        label: 'Total Group Creation Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with group creations through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_join_group: {
        label: 'Group Joins (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of group join events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_join_group: {
        label: 'Cost Per Group Join (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per group join attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_join_group_rate: {
        label: 'Group Join Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who joined groups as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_join_group: {
        label: 'Total Group Joins (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of group joins across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_join_group: {
        label: 'Cost Per Total Group Join (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total group joins across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_join_group_value: {
        label: 'Total Group Join Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with group joins through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Gaming Metrics
    skan_create_gamerole: {
        label: 'Game Role Creations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of game role creation events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_create_gamerole: {
        label: 'Cost Per Game Role Creation (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per game role creation attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_create_gamerole_rate: {
        label: 'Game Role Creation Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who created game roles as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_create_gamerole: {
        label: 'Total Game Role Creations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of game role creations across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_create_gamerole: {
        label: 'Cost Per Total Game Role Creation (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total game role creations across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_create_gamerole_value: {
        label: 'Total Game Role Creation Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with game role creations through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Credit Metrics
    skan_spend_credits: {
        label: 'Credit Spending (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of credit spending events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_spend_credits: {
        label: 'Cost Per Credit Spend (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per credit spending event attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_spend_credits_rate: {
        label: 'Credit Spending Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who spent credits as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_spend_credits: {
        label: 'Total Credit Spending (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of credit spending events across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_spend_credits: {
        label: 'Cost Per Total Credit Spend (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total credit spending events across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_spend_credits_value: {
        label: 'Total Credit Spending Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with credit spending through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Achievement Metrics
    skan_achieve_level: {
        label: 'Level Achievements (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of level achievement events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_achieve_level: {
        label: 'Cost Per Level Achievement (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per level achievement attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_achieve_level_rate: {
        label: 'Level Achievement Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who achieved levels as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_achieve_level: {
        label: 'Total Level Achievements (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of level achievements across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_achieve_level: {
        label: 'Cost Per Total Level Achievement (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total level achievements across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_achieve_level_value: {
        label: 'Total Level Achievement Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with level achievements through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_unlock_achievement: {
        label: 'Achievement Unlocks (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of achievement unlock events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_unlock_achievement: {
        label: 'Cost Per Achievement Unlock (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per achievement unlock attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_unlock_achievement_rate: {
        label: 'Achievement Unlock Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who unlocked achievements as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_unlock_achievement: {
        label: 'Total Achievement Unlocks (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of achievement unlocks across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_unlock_achievement: {
        label: 'Cost Per Total Achievement Unlock (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total achievement unlocks across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_unlock_achievement_value: {
        label: 'Total Achievement Unlock Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with achievement unlocks through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Sales Lead Metrics
    skan_sales_lead: {
        label: 'Sales Leads (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of sales lead events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_sales_lead: {
        label: 'Cost Per Sales Lead (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per sales lead attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_sales_lead_rate: {
        label: 'Sales Lead Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who became sales leads as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_sales_lead: {
        label: 'Total Sales Leads (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of sales leads across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_sales_lead: {
        label: 'Cost Per Total Sales Lead (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total sales leads across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_sales_lead_value: {
        label: 'Total Sales Lead Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with sales leads through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN In-App Ad Metrics
    skan_in_app_ad_click: {
        label: 'In-App Ad Clicks (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of in-app ad click events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_in_app_ad_click: {
        label: 'Cost Per In-App Ad Click (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per in-app ad click attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_in_app_ad_click_rate: {
        label: 'In-App Ad Click Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who clicked in-app ads as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_in_app_ad_click: {
        label: 'Total In-App Ad Clicks (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of in-app ad clicks across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_in_app_ad_click: {
        label: 'Cost Per Total In-App Ad Click (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total in-app ad clicks across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_in_app_ad_click_value: {
        label: 'Total In-App Ad Click Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with in-app ad clicks through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_in_app_ad_impr: {
        label: 'In-App Ad Impressions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of in-app ad impression events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_in_app_ad_impr: {
        label: 'Cost Per In-App Ad Impression (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per in-app ad impression attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_in_app_ad_impr_rate: {
        label: 'In-App Ad Impression Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who viewed in-app ads as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_in_app_ad_impr: {
        label: 'Total In-App Ad Impressions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of in-app ad impressions across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_in_app_ad_impr: {
        label: 'Cost Per Total In-App Ad Impression (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total in-app ad impressions across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_in_app_ad_impr_value: {
        label: 'Total In-App Ad Impression Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with in-app ad impressions through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Finance Metrics
    skan_loan_apply: {
        label: 'Loan Applications (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of loan application events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_loan_apply: {
        label: 'Cost Per Loan Application (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per loan application attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_loan_apply_rate: {
        label: 'Loan Application Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who applied for loans as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_loan_apply: {
        label: 'Total Loan Applications (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of loan applications across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_loan_apply: {
        label: 'Cost Per Total Loan Application (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total loan applications across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_loan_credit: {
        label: 'Loan Credits (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of loan credit events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_loan_credit: {
        label: 'Cost Per Loan Credit (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per loan credit attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_loan_credit_rate: {
        label: 'Loan Credit Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who received loan credits as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_loan_credit: {
        label: 'Total Loan Credits (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of loan credits across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_loan_credit: {
        label: 'Cost Per Total Loan Credit (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total loan credits across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_loan_disbursement: {
        label: 'Loan Disbursements (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of loan disbursement events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_loan_disbursement: {
        label: 'Cost Per Loan Disbursement (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per loan disbursement attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_loan_disbursement_rate: {
        label: 'Loan Disbursement Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who received loan disbursements as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_loan_disbursement: {
        label: 'Total Loan Disbursements (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of loan disbursements across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_loan_disbursement: {
        label: 'Cost Per Total Loan Disbursement (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total loan disbursements across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN User Engagement Metrics
    skan_login: {
        label: 'Logins (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of login events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_login: {
        label: 'Cost Per Login (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per login attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_login_rate: {
        label: 'Login Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who logged in as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_login: {
        label: 'Total Logins (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of logins across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_login: {
        label: 'Cost Per Total Login (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total logins across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_ratings: {
        label: 'Ratings (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of rating events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_ratings: {
        label: 'Cost Per Rating (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per rating attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_ratings_rate: {
        label: 'Rating Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who provided ratings as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_ratings: {
        label: 'Total Ratings (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of ratings across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_ratings: {
        label: 'Cost Per Total Rating (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total ratings across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_ratings_value: {
        label: 'Total Ratings Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with ratings through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_search: {
        label: 'Searches (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of search events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_search: {
        label: 'Cost Per Search (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per search attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_search_rate: {
        label: 'Search Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who performed searches as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_search: {
        label: 'Total Searches (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of searches across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_search: {
        label: 'Cost Per Total Search (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total searches across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Subscription Metrics
    skan_start_trial: {
        label: 'Trial Starts (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of trial start events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_start_trial: {
        label: 'Cost Per Trial Start (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per trial start attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_start_trial_rate: {
        label: 'Trial Start Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who started trials as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_start_trial: {
        label: 'Total Trial Starts (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of trial starts across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_start_trial: {
        label: 'Cost Per Total Trial Start (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total trial starts across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_subscribe: {
        label: 'Subscriptions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of subscription events attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_subscribe: {
        label: 'Cost Per Subscription (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per subscription attributed through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_subscribe_rate: {
        label: 'Subscription Rate (SKAN)',
        higherIs: 'positive',
        accumulation: 'weightedAverage',
        definition: "Percentage of users who subscribed as measured through Apple's SKAdNetwork.",
        formatting: 'percentage',
    },
    skan_total_subscribe: {
        label: 'Total Subscriptions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total number of subscriptions across all attribution windows through SKAdNetwork.',
        formatting: 'numeric',
    },
    skan_cost_per_total_subscribe: {
        label: 'Cost Per Total Subscription (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: 'Average cost per total subscriptions across all attribution windows through SKAdNetwork.',
        formatting: 'currency',
    },
    skan_total_subscribe_value: {
        label: 'Total Subscription Value (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: 'Total monetary value associated with subscriptions through SKAdNetwork.',
        formatting: 'currency',
    },
    // SKAN Special Attribution Metrics
    skan_vta_conversion: {
        label: 'VTA Conversions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of view-through attribution conversions attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_vta_conversion: {
        label: 'Cost Per VTA Conversion (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per view-through attribution conversion through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_vta_app_install: {
        label: 'VTA App Installs (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of view-through attribution app installs attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_vta_app_install: {
        label: 'Cost Per VTA App Install (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per view-through attribution app install through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_vta_registration: {
        label: 'VTA Registrations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of view-through attribution registrations attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_vta_registration: {
        label: 'Cost Per VTA Registration (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per view-through attribution registration through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_vta_purchase: {
        label: 'VTA Purchases (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of view-through attribution purchases attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_vta_purchase: {
        label: 'Cost Per VTA Purchase (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per view-through attribution purchase through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    // SKAN CTA Metrics
    skan_cta_conversion: {
        label: 'CTA Conversions (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of call-to-action conversions attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_cta_conversion: {
        label: 'Cost Per CTA Conversion (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per call-to-action conversion through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_cta_app_install: {
        label: 'CTA App Installs (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of call-to-action app installs attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_cta_app_install: {
        label: 'Cost Per CTA App Install (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per call-to-action app install through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_cta_registration: {
        label: 'CTA Registrations (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of call-to-action registrations attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_cta_registration: {
        label: 'Cost Per CTA Registration (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per call-to-action registration through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    skan_cta_purchase: {
        label: 'CTA Purchases (SKAN)',
        higherIs: 'positive',
        accumulation: 'sum',
        definition: "Number of call-to-action purchases attributed through Apple's SKAdNetwork.",
        formatting: 'numeric',
    },
    skan_cost_per_cta_purchase: {
        label: 'Cost Per CTA Purchase (SKAN)',
        higherIs: 'negative',
        accumulation: 'weightedAverage',
        definition: "Average cost per call-to-action purchase through Apple's SKAdNetwork.",
        formatting: 'currency',
    },
    video15Sec2SecVideoRetention: {
        label: '15s/2s Video Retention',
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        header: '15 Sec/3 Sec Video Retention',
        enabled: true,
        definition: 'The percentage of viewers who, after having watched your video for at least 3 seconds, continued to watch your video until the 15 second mark or completion. <>(Thruplays / Video Plays (3 Second Plays)) * 100<>',
    },
    spendPercentage: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        enabled: true,
        label: 'Spend %',
        definition: 'The percentage of spend allocated to an ad out of total spend. <>Spend / Total Spend Within Time Period * 100<>',
    },
    purchaseValuePercentage: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        enabled: true,
        label: 'Purchase Value %',
        definition: 'The percentage of purchase value attributed to a single ad out of total purchase value across your ads. <>Purchases (All) Value / Total Purchases (All) Value Within Time Period * 100<>',
    },
    clickToPurchaseRatio: {
        accumulation: 'weightedAverage',
        formatting: 'percentage',
        higherIs: 'positive',
        label: 'Click To Purchase Ratio',
        header: 'Click to Purchase Ratio',
        enabled: true,
        definition: 'The percentage of clicks that resulted in a purchase. <>(Purchases / Clicks (Links)) * 100<>',
    },
};
export const INSIGHTS_TIKTOK_ALL_ATTRIBUTES_AND_METRICS_GLOSSARY = {
    ...INSIGHTS_TIKTOK_AD_ATTRIBUTE_GLOSSARY,
    ...INSIGHTS_TIKTOK_ATTRIBUTE_GLOSSARY,
    ...INSIGHTS_TIKTOK_METRIC_GLOSSARY,
    ...INSIGHTS_TIKTOK_DERIVED_VALUES_GLOSSARY,
};
// https://business-api.tiktok.com/portal/docs?id=1751443967255553
export const INSIGHTS_TIKTOK_METRICS_INGESTED = Object.keys(TIKTOK_METRICS);
export const INSIGHTS_TIKTOK_ALL_FRONTEND_AVAILABLE_METRICS_AND_ATTRIBUTES = Array.from(new Set([
    ...INSIGHTS_TIKTOK_METRICS_INGESTED,
    ...Object.keys(INSIGHTS_TIKTOK_DERIVED_VALUES_GLOSSARY),
    ...Object.keys(INSIGHTS_TIK_TOK_FILTERABLE_AD_ATTRIBUTES),
    ...Object.keys(INSIGHTS_TIKTOK_METRIC_GLOSSARY),
    ...Object.keys(INSIGHTS_TIKTOK_SYNTHETIC_METRICS), // Add synthetic metrics
]));
//# sourceMappingURL=metric.js.map